import faker from 'faker';
import { sum } from 'lodash';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  Stack,
  Button,
  IconButton,
  TextField,
  LinearProgress,
  linearProgressClasses,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
  FormControl,
  Tabs,
  Tab,
  Autocomplete,
  Tooltip,
  Avatar
} from '@material-ui/core';
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js';
import { useLocation, useNavigate, useParams } from 'react-router'
import { Add, AddCircle, ArrowBackIos, ArrowForwardIos, Info, KeyboardBackspaceOutlined } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom'
// utils
import { fCurrency } from 'src/utils/formatNumber.js';
import { getJobCostMaterialCost, getJobCostMaterialRowTotals } from 'src/utils/jobCostMaterialCalc';
// Backup before JobCost recipeCost labor calc alignment:
// import { isJobCostInstallLaborPayout } from 'src/utils/laborTimelogCalc';
import {
  getRecipeCostLaborRowComputed,
  getJobCostTimelogLineCost,
  isJobCostInstallLaborPayout,
  isJobCostInstallLaborTimelog,
  resolveInstallLaborServiceUnitCost,
  resolveInstallLaborServiceLineCost,
  resolveJobCostServiceLineTotal,
  resolveEffectiveProductionLabor
} from 'src/utils/laborTimelogCalc';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import searchFill from '@iconify/icons-eva/search-fill';
import gridFill from '@iconify/icons-eva/grid-fill';
import checkmarkCircle2Fill from '@iconify/icons-eva/checkmark-circle-2-fill';

// components
import Page from 'src/components/Page.js';
import * as Yup from 'yup';
import Label from 'src/components/Label.js';
import Scrollbar from 'src/components/Scrollbar.js';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import InvoiceToolbar from 'src/components/_dashboard/e-commerce/invoice/InvoiceToolbar.js';
import JobCostToolbar from './JobCostToolbar';
import JobCostCartToolbar from './JobCostCartToolbar';
import ConfirmationPopup from 'src/components/confirmationPopup';
import Icon from '@iconify/react';
import { LoadingButton } from '@material-ui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import axios from 'axios';
import { COMPANY_NAME, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { useTheme, alpha } from '@material-ui/core/styles';
import { capitalCase } from 'change-case';
import CompareJobCost from './CompareJobCost';
import LoadingScreen from 'src/components/LoadingScreen';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'



// ----------------------------------------------------------------------

const INVOICE = {
  id: faker.datatype.uuid(),
  taxes: 5,
  discount: 10,
  status: 'paid',
  invoiceFrom: {
    name: faker.name.findName(),
    address: 'DieSachbearbeiter Choriner Straße 49 10435 Berlin',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  invoiceTo: {
    name: faker.name.findName(),
    address: 'Keas 69 Str. 15234, Chalandri Athens, Greece',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  items: [...Array(1)].map(() => ({
    id: faker.datatype.uuid(),
    title: faker.lorem.sentence(),
    description: faker.lorem.lines(),
    qty: faker.datatype.number({ min: 1, max: 5 }),
    price: faker.datatype.number({ min: 4, max: 99, precision: 0.01 })
  }))
};

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  cursor: 'pointer',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',

    WebkitBackdropFilter: 'blur(3px)',
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,

  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',

})

// Alphanumeric comparison helper function (natural sort) - same as OfficialRequestAdd.js
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    let normalized = str.toString().trim();
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null;

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;

      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3;
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

const MATERIAL_GRID_COLS = 3;
const MATERIAL_CARD_ROW_HEIGHT = 148;
const MATERIAL_GRID_VIEWPORT_HEIGHT = 402;

const MaterialPickerCard = memo(function MaterialPickerCard({
  post,
  stockQty,
  isTabRestricted,
  showOwnershipSuffix,
  onCardClick,
  allowOutOfStockClick = false,
}) {
  const theme = useTheme();
  const isOutOfStock = !stockQty || Number(stockQty) <= 0;
  const blockClickStyle = isTabRestricted || (isOutOfStock && !allowOutOfStockClick);
  const ownershipLabel = post?.inhouse ? 'Inhouse' : 'Client owned';
  const tooltipTitle = `${post.name} (${ownershipLabel})`;

  return (
    <Grid item xs={6} sm={4} md={4}>
      <Card
        sx={{
          minWidth: 100,
          transition: 'transform 0.2s',
          // '&:hover': { transform: 'scale(1.02)' },
          // cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
          border: isOutOfStock ? `1px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.primary.main}`,
          opacity: isOutOfStock ? 0.75 : 1,
          '&:hover': {
            transform: blockClickStyle ? 'none' : 'scale(1.02)',
          },
          cursor: blockClickStyle ? 'default' : 'pointer',
        }}
        // onMouseEnter={() => setIsHover(true)}
        // onMouseLeave={() => setIsHover(false)}
        onClick={() => onCardClick(post, isOutOfStock)}
      >
        <Box
          sx={{
            p: 2,
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // height: 'auto',
            height: '80px',
            overflow: 'hidden',
          }}
        >
          <Stack
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
              height: '100%',
            }}
          >
            {/* <Tooltip title={tooltipTitle}>
              <Typography variant="body2" align="center" ...>{post.name}</Typography>
            </Tooltip> */}
            <Typography
              variant="body2"
              align="center"
              title={tooltipTitle}
              sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: 3,
                lineHeight: '1.2',
                maxHeight: '3.6em',
                fontSize: '14px',
                // cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
              }}
            >
              {/* {post.name + ` (${post?.inhouse ? 'I' : 'C'})`} */}
              {showOwnershipSuffix
                ? `${post.name} (${post?.inhouse ? 'I' : 'C'})`
                : post.name}
            </Typography>
          </Stack>
        </Box>
        <Divider />
        <Box
          sx={{
            p: 2,
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: 'auto',
            overflow: 'hidden',
          }}
        >
          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <Typography
              variant="caption"
              align="center"
              sx={{
                marginTop: 0.5,
                fontSize: '12px',
                // color: 'gray',
                color: isOutOfStock ? 'error.main' : 'inherit',
              }}
            >
              {/* Stock : {stockQty} */}
              {isOutOfStock ? 'Out of stock' : `Stock : ${stockQty}`}
            </Typography>
          </Stack>
        </Box>
      </Card>
    </Grid>
  );
});

const MaterialPickerGrid = memo(function MaterialPickerGrid({
  items,
  isTabRestricted,
  showOwnershipSuffix,
  getStockQty,
  onCardClick,
  allowOutOfStockClick = false,
}) {
  const [scrollTop, setScrollTop] = useState(0);
  const scrollRafRef = useRef(null);

  const handleScroll = useCallback((event) => {
    const nextScrollTop = event.currentTarget.scrollTop;
    if (scrollRafRef.current) {
      cancelAnimationFrame(scrollRafRef.current);
    }
    scrollRafRef.current = requestAnimationFrame(() => {
      setScrollTop(nextScrollTop);
    });
  }, []);

  const rowCount = Math.ceil((items?.length || 0) / MATERIAL_GRID_COLS);
  const totalHeight = rowCount * MATERIAL_CARD_ROW_HEIGHT;
  const overscanRows = 2;
  const startRow = Math.max(0, Math.floor(scrollTop / MATERIAL_CARD_ROW_HEIGHT) - overscanRows);
  const endRow = Math.min(
    rowCount,
    Math.ceil((scrollTop + MATERIAL_GRID_VIEWPORT_HEIGHT) / MATERIAL_CARD_ROW_HEIGHT) + overscanRows
  );
  const startIndex = startRow * MATERIAL_GRID_COLS;
  const endIndex = Math.min(items.length, endRow * MATERIAL_GRID_COLS);
  const visibleItems = items.slice(startIndex, endIndex);
  const paddingTop = startRow * MATERIAL_CARD_ROW_HEIGHT;
  const paddingBottom = Math.max(0, totalHeight - endRow * MATERIAL_CARD_ROW_HEIGHT);

  return (
    <Box
      onScroll={handleScroll}
      sx={{
        height: MATERIAL_GRID_VIEWPORT_HEIGHT,
        overflowY: 'auto',
        '&::-webkit-scrollbar': { width: '0.4em' },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.1)',
          borderRadius: '4px',
        },
      }}
    >
      <Box sx={{ pt: `${paddingTop}px`, pb: `${paddingBottom}px` }}>
        <Grid container spacing={1}>
          {visibleItems.map((post) => (
            <MaterialPickerCard
              key={post.id ?? post.product_id ?? post.name}
              post={post}
              stockQty={getStockQty(post)}
              isTabRestricted={isTabRestricted}
              showOwnershipSuffix={showOwnershipSuffix}
              onCardClick={onCardClick}
              allowOutOfStockClick={allowOutOfStockClick}
            />
          ))}
        </Grid>
      </Box>
    </Box>
  );
});

const getOtherEntriesTotals = (entries = []) => {
  const list = Array.isArray(entries) ? entries : [];
  return list.reduce(
    (acc, entry) => {
      const quantity = Number(entry?.quantity ?? 0);
      const unitCost = Number(entry?.unit_cost ?? 0);
      const unitBill = Number(entry?.unit_bill ?? 0);
      const totalCostFromRow = Number(entry?.total_cost);
      const totalBillFromRow = Number(entry?.total_bill);
      const billable = entry?.billable === 1 || entry?.billable === '1' || entry?.billable === true;

      const rowCost = Number.isFinite(totalCostFromRow) ? totalCostFromRow : (Number.isFinite(quantity) ? quantity : 0) * (Number.isFinite(unitCost) ? unitCost : 0);
      const rawBill = Number.isFinite(totalBillFromRow) ? totalBillFromRow : (Number.isFinite(quantity) ? quantity : 0) * (Number.isFinite(unitBill) ? unitBill : 0);
      const rowBill = billable ? rawBill : 0;

      acc.cost += rowCost;
      acc.bill += rowBill;
      return acc;
    },
    { cost: 0, bill: 0 }
  );
};

// Backup before JobCost recipeCost labor calc alignment: service?.taken !== 1 checks only.
/** Include job-cost service rows in totals when DB has qty/cost even if taken is 0 */
const includeRecipeCostServiceRow = (service) => {
  if (!service) return false;
  if (service.taken === 1 || service.taken === '1') return true;
  if (parseFloat(service.jobcost_quantity || 0) > 0) return true;
  if (parseFloat(service.jobcost_total_cost || service.total_cost || 0) > 0) return true;
  if (parseFloat(service.qty || 0) > 0) return true;
  if (parseFloat(service.total_bill || 0) > 0) return true;
  if (parseFloat(service.jobcost_total_bill || 0) > 0) return true;
  return false;
};

// ----------------------------------------------------------------------

// Backup before JobCost labor refresh props:
// export default function JobCost({jobCostId,handleClickOpenRecipeCost,setRecipeCostCurrentTab,handleBackToAlljobs,popupOn,onDataChange,isModal}) {
export default function JobCost({
  jobCostId,
  handleClickOpenRecipeCost,
  setRecipeCostCurrentTab,
  handleBackToAlljobs,
  popupOn,
  onDataChange,
  isModal,
  staffTimelogsProp,
  laborTabLaborCost,
  refreshTrigger
}) {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const [details, setDetails] = useState(null);
  // Backup before T&M material markup fix: const isTMProject = details?.project_category === 12;
  const isTMProject = Number(details?.project_category) === 12 || details?.job_category_name === 'Time & Material';
  const isProductServiceRequired = Number(details?.project_category) !== 12;
  const user = JSON.parse(window.localStorage.getItem('user'))
  const subTotal = sum(INVOICE.items.map((item) => item.price * item.qty));
  const total = subTotal - INVOICE.discount + INVOICE.taxes;
  const location = useLocation();
  const currentTabNew = location?.state?.currentTab
  const isTabRestricted = currentTabNew === 'Installations' || currentTabNew === 'Completed' || currentTabNew === 'Hold'
  const isEstimateJob = location?.state?.isEstimateJob
      const tableContainerRef = useRef(null);
  const [futureInstallations, setFutureInstallations] = useState([]);

          const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };


  console.log('location-123-',location);
  console.log('currentTabNew--',currentTabNew);
  const params = localStorage.getItem("params");
  const ACCOUNT_TABS = [
    {
      value: 'Materials',
      name: 'Materials',

    },
    ...(details?.job_category_name !== 'Time & Material' ? [{
      value: 'STOCK CATALOGS',
      name: 'STOCK CATALOGS',
    }] : []),
    // {
    //   value: 'Services',
    //   name: 'Services',
    // },
  ]
  // const [isHover, setIsHover] = useState(false)
  const [productList, setProductList] = useState([]);
  const [initialMaterials, setInitialMaterials] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [catalogList, setCatalogList] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [filterName, setFilterName] = useState('');
  /** false = All materials; true = In stock only (hide out of stock cards). */
  const [inStockOnly, setInStockOnly] = useState(false);
  const [openDeletePop, setOpenDeletePop] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [renderCards, setRenderCards] = useState(false)
  const [materialsPreview, setMaterialsPreview] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isMaterialDeleteLoading, setIsMaterialDeleteLoading] = useState(false)
  const [selectedMaterial, setSelectedMaterial] = useState()
  const [manualTotalPayOut, setManualTotalPayOut] = useState(0)
  const [hourlyTotalPayOut, setHourlyTotalPayOut] = useState(0)
  const [excessHourlyPayoutAmount, setExcessHourlyPayoutAmount] = useState(0)
  const [excessManualPayoutAmount, setExcessManualPayoutAmount] = useState(0)
  const [manuallyAddedPayouts, setManuallyAddedPayouts] = useState([])
  // Backup before JobCost labor refresh props: no allPayouts / staffTimelogsGet state.
  const [allPayouts, setAllPayouts] = useState([])
  const [staffTimelogsGet, setStaffTimelogsGet] = useState([])
  // Backup before JobCost labor refresh props: no staffTimelogsProp / laborTabLaborCost from recipeCost parent.
  const timelogsForCalc = useMemo(
    () => (staffTimelogsProp != null ? staffTimelogsProp : staffTimelogsGet),
    [staffTimelogsProp, staffTimelogsGet]
  );
  const [jobCost, setJobCost] = useState(0)
  const [recipe, setRecipe] = useState([])
  const [isRecipe, setIsRecipe] = useState(false)
  const [ingredient, setIngredient] = useState(false)
  const [materialPayOut, setMaterialPayOut] = useState(0)
  const [selectedServices, setSelectedServices] = useState([])
  const [services, setServices] = useState([])
  const [otherEntries, setOtherEntries] = useState([])
  const [stockProducts, setStockProducts] = useState([])
  const [allServices, setAllServices] = useState([])
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [color, setColor] = useState('#308fe8')
  const [errorFieldId, setErrorFieldId] = useState([]);
  const [currentTab, setCurrentTab] = useState('Materials')
  const [tab, setTab] = useState(false)
  const [jobCostPreview, setJobCostPreview] = useState(false)
  // const [details, setDetails] = useState(null);
  const handleChangeTab = (event, newValue) => {
    if (newValue == 'Materials') {
      setCurrentTab(newValue);
      setTab(false);
    } else if (newValue == 'STOCK CATALOGS' && details?.job_category_name !== 'Time & Material') {
      setCurrentTab(newValue);
      setTab(true);
    }
  };
  const logo = 'https://www.shutterstock.com/image-photo/checklist-clipboard-task-documentation-management-260nw-2270860299.jpg'

  const { id:paramsId } = useParams();
  const  id  = popupOn ? jobCostId: paramsId

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, // `hsl(${(progressValue * 1.2)}, ${60 + (progressValue * 0.4)}%, 50%)`
    },
  }));
  const fetchAllProductCategory = async () => {
    setLoading(true);
    try {
      axios
        .post(REST_API_END_POINT + 'product/get-all-product-categories')
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            // let length = data.productCategories.length + 2
            // console.log("length", length);
            // let recipe = {
            //   "id": length,
            //   "name": "Services",
            //   "added_by": 1,
            //   "status": 1,
            //   "timestamp": 1711096046,
            //   "c_id": 1,
            //   "authorized_by": "Rakesh Skyniche"
            // }
            // data.productCategories.push(recipe);
            console.log("######################Data.product", data.productCategories);
            //  setCategory(data.productCategories)
            let allCategory={
              id:1212121,
              name:"ALL"
            }
            setCategory([allCategory,...data.productCategories]);
            setSelectedCategory(allCategory.id);

          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }finally{
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }
  console.log("############CAAA", category);
  useEffect(() => {
    fetchData()
    fetchAllProductCategory()
  // Backup before JobCost labor refresh props: }, [renderCards]);
  }, [renderCards, refreshTrigger]);
  // Backup before JobCost recipeCost labor calc alignment: let grandTotalCost = 0

  const fetchFinishedProductsData = async () => {
    try {
      const finishedProductsResponse = await axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-add-materials-finished-products`);
      return Array.isArray(finishedProductsResponse?.data?.results)
        ? finishedProductsResponse.data.results
        : [];
    } catch (error) {
      console.error('Error fetching finished products:', error);
      return [];
    }
  };

  // Old code:
  // const fetchData = async () => {
  const fetchData = async (showPageLoader = true) => {
    // Old code:
    // setLoading(true);
    if (showPageLoader) {
      setLoading(true);
    }
    try {
      const freshProductListData = await fetchFinishedProductsData();
      const response = await axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-add-materials`, { userId: user.user_id, projectId: id, orderId: params });
        const apiResults = response?.data?.results;
        const productListData =
          Array.isArray(freshProductListData) && freshProductListData.length > 0
            ? freshProductListData
            : Array.isArray(apiResults) && apiResults.length > 0
            ? apiResults
            : Array.isArray(productList)
            ? productList
            : [];
        const selectedProducts = response.data.selectedMaterials
        let initialData = response.data.selectedMaterials
        const allPayouts = response.data.allPayOut
        const project = response.data.projects
        const allMaterials = response.data.allMaterials
        const allCatalogs = response.data.allCatalogs
        const allRecipes = response.data.allRecipies
        const material = response.data.materials
        let allServices = response.data.allServices
        let services = response.data.services
        let stockProducts = response.data.stockProducts

        let selectedServices = response.data.selectedServices
        const fetchedOtherEntries = response.data.otherEntries
        if (services) {
          setServices(services)
        }
        if (selectedServices) {
          setSelectedServices(selectedServices)
        }
        if (allServices) {
          setAllServices(allServices)
        }
        if (allRecipes) {
          setRecipe(allRecipes)
        }
        if (material?.length > 0) {
          const data = material
            ?.filter(curr => curr.taken === 1)
            ?.reduce((acc, curr) => {
              return acc + curr.total;
            }, 0);
          setMaterialPayOut(data);
        }
        if (allPayouts?.length > 0) {
          // Backup before JobCost labor refresh props: no setAllPayouts(allPayouts) here.
          setAllPayouts(allPayouts);
          let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
          
          // Store manually added payouts for production labor
          const fetchedIsTM = Number(project?.project_category) === 12 || project?.job_category_name === 'Time & Material';
          const manualPayouts = allPayouts.filter(
            // Backup before T&M production labor fix: p => (p.is_manually_added === 1 || p.is_manually_added === "1") && (p.service_id === null || p.service_id === undefined || p.service_id === 0 || !p.service_id)
            // Backup before Install Labor request-service classification:
            // p => (p.is_manually_added === 1 || p.is_manually_added === "1") &&
            //      (p.service_id === null || p.service_id === undefined || p.service_id === 0 || !p.service_id) &&
            //      (!fetchedIsTM || !isJobCostInstallLaborPayout(p))
            p => (p.is_manually_added === 1 || p.is_manually_added === "1") && 
                 (p.service_id === null || p.service_id === undefined || p.service_id === 0 || !p.service_id) &&
                 (!fetchedIsTM || !isJobCostInstallLaborPayout(p, services))
          );
          setManuallyAddedPayouts(manualPayouts || []);
          
          const totalHourlyPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay === 1 && !payout.service_id && !payout.is_manually_added)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessHourlyPayoutAmount(totalHourlyPayoutAmount)
          const totalManualPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay !== 1 && !payout.service_id && !payout.is_manually_added)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessManualPayoutAmount(totalManualPayoutAmount)

          setHourlyTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay === 1).reduce((acc, curr) => acc + curr.amount, 0))
          setManualTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay !== 1).reduce((acc, curr) => acc + curr.amount, 0))
        } else {
          setAllPayouts([]);
        }
        // Backup before JobCost labor refresh props: no staff timelog fetch in fetchData.
        if (project) {
          try {
            const requestId = project?.request_id || params;
            if (id && requestId) {
              const timelogRes = await axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-recipe`, {
                userId: user.user_id,
                userType: user.user_type,
                projectId: id,
                orderId: requestId
              });
              if (timelogRes?.data?.newstafftimelogs) {
                setStaffTimelogsGet(timelogRes.data.newstafftimelogs);
              }
            }
          } catch (timelogErr) {
            console.error('Error fetching staff timelogs for job cost:', timelogErr);
          }
        }
        if (initialData) {
          setInitialMaterials(initialData)
        }
        if (productListData) {
          setProductList(productListData)
        }
        if (allMaterials) {
          const filteredMaterials = project?.job_category_name == 'Service only' ? allMaterials : allMaterials?.filter(item=>item.inhouse == 1)
          setMaterialList(filteredMaterials)
        }
        if (allCatalogs) {
          const filteredCatalogs = allCatalogs?.filter(item=>{
            item.inhouse !== 1 && item.isTrafficCatalog == 0
          })
          setCatalogList(allCatalogs)
        }
        if (project) {
          setJobCost(project.cost || 0)
        }
        if (stockProducts) {
          setStockProducts(stockProducts)
        }
        setOtherEntries(Array.isArray(fetchedOtherEntries) ? fetchedOtherEntries : [])
        if (project) {
          setDetails(project || null);
        }
        if (response.data.selectedMaterials?.length) {
          setSelectedProjects(productListData?.filter(item1 =>
            selectedProducts?.some(item2 => item1.id === item2.product_id)
          ).map(item1 => {
            let match = selectedProducts?.find(item2 => item1.id === item2.product_id);
            console.log('item1========',item1)
            console.log('match========',match)
            return { ...item1, ...(match ? 
              { product_id: match.id, 
                unit: match?.partial_unit ? match?.partial_unit : item1?.unit,
                // unit_cost:(match?.unit_cost && match?.unit_cost > 0) ? match.unit_cost : match.material_unit_cost, 
                unit_cost: item1?.inhouse == 0 ? 0 : match?.unit_cost > 0 ? match.unit_cost : match?.material_unit_cost || 0,
                total:match.total, 
                quantity: match.quantity, 
                price: match.price, 
                match_actual_quantity: match.actual_quantity, 
                match_actual_total: match.actual_total, 
                match_actual_unit_price: match.actual_unit_price,
                taken: match?.taken || 0,
                customer_order_product_id: match?.customer_order_product_id ||  null,
                material_id : match?.material_id || null,
                partial : match?.partial ,
                partial_unit : match?.partial_unit || null,
                markup: match?.markup || match?.markup_percent || match?.material_markup_percentage || item1?.retail_price || item1?.markup || 0,
                markup_percent: match?.markup_percent,
                material_markup_percentage: match?.material_markup_percentage || item1?.retail_price,
                product_markup: match?.product_markup,
                isMaterial: match?.isMaterial || 0,
                for_product: match?.for_product || null,
                for_service: match?.for_service || null
              } : {}) };
          }))
        } else {
          setSelectedProjects([])
        }
    }catch (error) {
      console.error("Error fetching data:", error);
    }finally{
      // Old code:
      // setTimeout(() => {
      //   setLoading(false)
      // }, 1000);
      if (showPageLoader) {
        setTimeout(() => {
          setLoading(false)
        }, 1000);
      }
    }
  }
  const handleAddService = (service) => {
    console.log("################service", service);
    service.qty = 1
    service.originalCost = service.cost
    if (!selectedServices.some((item) => (item.labour_cost_service_id || item.id) === service.id)) {
      setSelectedServices([...selectedServices, service]);
    } else {
      enqueueSnackbar("Service already in cart", { variant: 'error' });
      console.log('Service already added');
    }
  };
  const handleQuantityChange = (index, newValue) => {
    const updatedServices = [...selectedServices];
    updatedServices[index].qty = newValue;
    setSelectedServices(updatedServices);
  };
  const handleDeleteService = (index) => {
    const updatedServices = [...selectedServices];
    updatedServices.splice(index, 1);
    setSelectedServices(updatedServices);
  };
  console.log("###################selectedServices", selectedServices);
  function isSumGreater(productId, valQty) {
    let sum = 0;
    initialMaterials?.forEach(material => {
      if (material.product_id === productId) {
        sum += material.quantity;
      }
    });
    productList?.forEach(product => {
      if (product.id === productId) {
        sum += product.qty;
      }
    });
    return sum < Number(valQty);
  }
  useEffect(() => {
    const errorFields = [];
    setErrorFieldId([]);
    selectedProjects?.forEach((val) => {
      const result = isSumGreater(val.productId, val.quantity);
      if (result && !isTMProject) {
        errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
      }
    });
    selectedProjects?.forEach((val) => {
      if (val.quantity <= 0) {
        errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
      }
    });
    if (errorFields.length > 0) {
      setErrorFieldId([])
      setErrorFieldId(errorFields);
    }
  }, [selectedProjects, manualTotalPayOut, hourlyTotalPayOut])

  const fetchAllFutureInstallations = async () => {
    axios.post(`${REST_API_END_POINT}project/fetch-all-future-installations`,{projectId :id}).then((response) => {
      if (response.data.status === 1) {
        setFutureInstallations(response?.data?.futureInstallation || []);
      }
    }).catch((error) => {
      console.error('Error fetching data:', error);
    })
  }
  useEffect(() => {
    if(details?.project_category !== 12 && futureInstallations?.length === 0){
      fetchAllFutureInstallations();
    }
  }, [details]);
  const handleProjectClick = (project) => {
    console.log('project123---',project)
    // Backup before T&M material markup fix: const isTMProject = details?.project_category === 12;
    const unitCost = project.inhouse === 0 ? 0 : project.unit_cost;
    // setSelectedProjects(prevSelectedProjects => [...prevSelectedProjects, project]);
    setSelectedProjects(prevSelectedProjects => [
      ...prevSelectedProjects,
      {
        ...project,
        unit : project?.partial_unit ? project?.partial_unit : project?.unit,
        unit_cost: unitCost, // Set unit_cost to 0 if inhouse is 0
        // Backup before T&M material markup: jobcost_total was not set here.
        jobcost_total: getJobCostMaterialCost(project, isTMProject, {
          qty: project.quantity,
          unitCost
        }),
        material_name : project?.name,
        isMaterial: (project?.isMaterial || 0)
      }
    ]);
    enqueueSnackbar('Material added to the list', { variant: 'success' });
  };
  console.log('selectedProjects===',selectedProjects)
  const NewUserSchema = Yup.object().shape({
    quantity: Yup.number().min(1, 'Quantity must be at least 1').test('valid-quantity', 'Enter a valid quantity', (value) => value > 0).required('Quantity is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: 1,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      console.log('Selected Projects before submit:', selectedProjects);
      try {
        // if(selectedProjects?.length > 0){
        const values = selectedProjects?.map(project => ({
          ...(project.product_id ? { id: project.product_id } : {}),
          productId: project.id,
          projectId: id,
          // actual_quantity: project.actual_quantity,
          // actual_unit_cost: project.actual_unit_cost,
          // actual_total: project.actual_total,
          actual_quantity: isTMProject ? Number(project.quantity) : project.match_actual_quantity, // project.unit_qty || 0,
          actual_unit_cost: project.match_actual_unit_price, // project.unit_cost || 0,
          actual_total: project.match_actual_total, // project.actual_total_cost || 0,
          quantity: Number(project.quantity),
          unitPrice: project?.inhouse == 0 ? 0 : project.unit_cost,
          task_id: project.task_id || null,
          // Backup before T&M material markup: total: project?.inhouse == 0 ? 0 : (Number(project.unit_cost) * Number(project.quantity)),
          total: getJobCostMaterialCost(project, isTMProject, {
            qty: project.quantity,
            unitCost: project?.inhouse == 0 ? 0 : project.unit_cost
          }),
          customer_order_product_id: project?.customer_order_product_id || null,
          material_name:project?.name || '',
          material_id : project?.material_id || null ,
          partial : project?.partial || 0 ,
          partial_unit : project?.partial_unit || null,
          markup : project?.markup || 0,
          // Backup before T&M material markup fix: only markup was sent here.
          markup_percent: project?.markup_percent || project?.markup || 0,
          material_markup_percentage: project?.material_markup_percentage || project?.markup || 0,
          product_markup: project?.product_markup || project?.markup || 0,
          for_product: project?.for_product || null,
          for_service: project?.for_service || null
        }))
        function isSumGreater(productId, valQty) {
          let sum = 0;
          initialMaterials?.forEach(material => {
            if (material.product_id === productId) {
              sum += material.quantity;
            }
          });
          productList?.forEach(product => {
            if (product.id === productId) {
              sum += product.qty;
            }
          });
          return sum < Number(valQty);
        }
        const errorFields = [];
        if (isProductServiceRequired) {
          selectedProjects?.forEach((project) => {
            if (project.isMaterial === 1 && !project.for_product && !project.for_service) {
              errorFields.push({ productId: project.id, errorText: 'Product/Service is required' });
            }
          });
        }
        values.forEach((val) => {
          const result = isSumGreater(val.productId, val.quantity);
          if (result && !isTMProject) {
            errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
          }
        });
        values.forEach((val) => {
          if (val.quantity <= 0) {
            errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
          }
        });
        if (errorFields.length > 0) {
          setErrorFieldId([])
          setErrorFieldId(errorFields);
          // setRenderCards(!renderCards)
          return;
        }

        setErrorFieldId([])
        const response = await axios.post(
          `${REST_API_END_POINT}project/add-job-cost`,
          { userId: user.user_id, values, projectId: id, recipe: 0, selectedServices, requestId: params },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
          // Old code:
          // handleClick();
          // Redirect to Recipe Cost -> Materials tab right after successful submit.
          handleClick('Materials');
        } else if (response?.data?.message) {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        } else {
          enqueueSnackbar('Error adding Jobcost 1', { variant: 'error' });
        }
        setRenderCards(!renderCards)
        if(popupOn){
          onDataChange()
        }
        // }else{
        //   enqueueSnackbar('Please select a material', { variant: 'error' });
        // }
      } catch (error) {
        console.error(error);
        console.log('errorrrrrrrrrr', error)
        enqueueSnackbar('Error adding Jobcost 2', { variant: 'error' });
      } finally {
        setSubmitting(false);
      }
    }
  });

  console.log('selectedProjects----',selectedProjects);

  const handleDeleteSubmit = async (deletedId) => {
    const nextSelectedProjects = selectedProjects.filter(selected => selected.id !== deletedId);
    setIsMaterialDeleteLoading(true);
    try {
      // console.log('deletedId----',deletedId);
      // Old code:
      // setSelectedProjects([...selectedProjects.filter(selected => selected.id !== deletedId)])
      setSelectedProjects(nextSelectedProjects)
      // Old code:
      // const values = selectedProjects?.filter(selected => selected.id !== deletedId)?.map(project => ({
      const values = nextSelectedProjects?.map(project => ({
        ...(project.product_id ? { id: project.product_id } : {}),
        productId: project.id,
        projectId: id,
        // actual_quantity: project.actual_quantity,
        // actual_unit_cost: project.actual_unit_cost,
        // actual_total: project.actual_total,
        actual_quantity: isTMProject ? Number(project.quantity) : project.match_actual_quantity, // project.unit_qty || 0,
        actual_unit_cost: project.match_actual_unit_price, // project.unit_cost || 0,
        actual_total: project.match_actual_total, // project.actual_total_cost || 0,
        quantity: project.quantity,
        task_id: project.task_id || null,
        unitPrice: project?.inhouse == 0 ? 0 : project.unit_cost,
        // Backup before T&M material markup: total: project?.inhouse == 0 ? 0 : (Number(project.unit_cost) * Number(project.quantity)),
        total: getJobCostMaterialCost(project, isTMProject, {
          qty: project.quantity,
          unitCost: project?.inhouse == 0 ? 0 : project.unit_cost
        }),
        customer_order_product_id: project?.customer_order_product_id || null,
        material_name:project?.name || '',
        material_id : project?.material_id || null ,
        partial : project?.partial || 0 ,
        partial_unit : project?.partial_unit || null,
        markup : project?.markup || 0,
        // Backup before T&M material markup fix: only markup was sent here.
        markup_percent: project?.markup_percent || project?.markup || 0,
        material_markup_percentage: project?.material_markup_percentage || project?.markup || 0,
        product_markup: project?.product_markup || project?.markup || 0

      }))
      function isSumGreater(productId, valQty) {
        let sum = 0;
        initialMaterials?.forEach(material => {
          if (material.product_id === productId) {
            sum += material.quantity;
          }
        });
        productList?.forEach(product => {
          if (product.id === productId) {
            sum += product.qty;
          }
        });
        return sum < Number(valQty);
      }
      const errorFields = [];
      values.forEach((val) => {
        const result = isSumGreater(val.productId, val.quantity);
        if (result && !isTMProject) {
          errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
        }
      });
      values.forEach((val) => {
        if (val.quantity <= 0) {
          errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
        }
      });
      if (errorFields.length > 0) {
        setErrorFieldId([])
        setErrorFieldId(errorFields);
        setIsMaterialDeleteLoading(false);
        return;
      }
      else {
        setErrorFieldId([])
        // console.log('values-------------',values);
        // Old code:
        // axios.post(`${REST_API_END_POINT}project/add-job-cost`, { userId: user.user_id, values, projectId: id, recipe: 0,requestId: params }, {
        const response = await axios.post(`${REST_API_END_POINT}project/add-job-cost`, { userId: user.user_id, values, projectId: id, recipe: 0,requestId: params }, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        // Old code:
        // }).then((response) => {
        //   if (response.data.status === 1) {
        //     enqueueSnackbar(response.data.message, { variant: 'success' });
        //   } else if (response?.data?.message) {
        //     enqueueSnackbar(response.data.message, { variant: 'error' });
        //   } else {
        //     enqueueSnackbar('Error adding Jobcost 4', { variant: 'error' });
        //   }
        //   if(popupOn){
        //     onDataChange()
        //   }
        //   setSelectedProjects([])
        //   setManualTotalPayOut(0)
        //   setHourlyTotalPayOut(0)
        //   setInitialMaterials([])
        //   setProductList([])
        //   setMaterialList([])
        //   setJobCost(0)
        //   setDeleteId();
        //   // fetchData()
        //   setRenderCards(!renderCards)
        //   if(popupOn){
        //     onDataChange()
        //   }
        // }).catch((error) => {
        //   console.error(error);
        //   enqueueSnackbar('Error adding Jobcost 5', { variant: 'error' });
        // })
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
        } else if (response?.data?.message) {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        } else {
          enqueueSnackbar('Error adding Jobcost 4', { variant: 'error' });
        }
        if(popupOn && onDataChange){
          onDataChange()
        }
        // Old code commented because clearing these before refresh made the UI look empty.
        // if(popupOn){
        //   onDataChange()
        // }
        // setSelectedProjects([])
        // setManualTotalPayOut(0)
        // setHourlyTotalPayOut(0)
        // setInitialMaterials([])
        // setProductList([])
        // setMaterialList([])
        // setJobCost(0)
        setDeleteId();
        // Old code:
        // fetchData()
        // setRenderCards(!renderCards)
        // if(popupOn){
        //   onDataChange()
        // }
        await fetchData(false)
      }
    } catch (error) {
      console.error(error);
      // Old code:
      // enqueueSnackbar('Error adding Jobcost 6', { variant: 'error' });
      enqueueSnackbar('Error adding Jobcost 5', { variant: 'error' });
    } finally {
      setIsMaterialDeleteLoading(false);
    }
  }

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };
  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;
  // const materialWithStock = materialList?.filter((data) => data?.total_qty > 0)
  // const catalogWithStock = catalogList?.filter((data) => data?.finishedProductQty > 0)
  const productWithQty = productList?.filter((data) => isTMProject || data?.qty > 0)
  const sortMaterialsByName = useCallback((items) =>
    [...(items || [])].sort((a, b) => {
      const aValue = a?.description || a?.name || '';
      const bValue = b?.description || b?.name || '';
      return alphanumericCompare(aValue, bValue);
    }), []);

  const filterPickerItems = useCallback((list) => {
    const search = (filterName || '').toLowerCase();
    return (list || []).filter((material) => {
      const matchesSearch = search ? material.name.toLowerCase().includes(search) : true;
      const matchesCategory =
        selectedCategory && selectedCategory !== 1212121
          ? material.category_id === selectedCategory
          : true;
      const isActive = Number(material.status) === 1;
      return matchesSearch && matchesCategory && isActive;
    });
  }, [filterName, selectedCategory]);

  const filteredCatalogList = useMemo(() => {
    const list = sortMaterialsByName(filterPickerItems(catalogList));
    if (!inStockOnly) return list;
    return list.filter((post) => {
      const stockQty = Number(post?.finishedProductQty);
      return Number.isFinite(stockQty) && stockQty > 0;
    });
  }, [catalogList, filterPickerItems, sortMaterialsByName, inStockOnly]);

  const filteredMaterialList = useMemo(() => {
    const list = sortMaterialsByName(filterPickerItems(materialList));
    if (!inStockOnly) return list;
    return list.filter((post) => {
      const stockQty = Number(post?.total_qty);
      return Number.isFinite(stockQty) && stockQty > 0;
    });
  }, [materialList, filterPickerItems, sortMaterialsByName, inStockOnly]);

  const handlePickerCardClick = useCallback((post, isOutOfStock) => {
    if (isTabRestricted) return;

    // Finished/partial inventory lines for this material/catalog.
    const inventoryLines = (Array.isArray(productList) ? productList : []).filter(
      (row) => Number(row?.material_id) === Number(post?.id)
    );
    const hasPositiveQty = inventoryLines.some((row) => Number(row?.qty) > 0);

    // T&M: open popup for any finished/partial lines (qty 0 or more).
    // Normal: open popup only when at least one line has qty > 0.
    const shouldOpenPopup = isTMProject
      ? inventoryLines.length > 0
      : hasPositiveQty;

    if (shouldOpenPopup) {
      setMaterialsPreview(true);
      setSelectedMaterial(post);
      return;
    }

    enqueueSnackbar('Material is out of stock', { variant: 'error' });
  }, [isTabRestricted, enqueueSnackbar, isTMProject, productList]);

  const getCatalogStockQty = useCallback((post) => post?.finishedProductQty, []);
  const getMaterialStockQty = useCallback((post) => post?.total_qty, []);

  const navigate = useNavigate()

  const linkState = {
    pathname: `${PATH_DASHBOARD.project.recipeCost}/${id}`,
    state: { request: params,currentTab : currentTabNew, isEstimateJob:isEstimateJob }
  };

  // Changed to accept a target tab so submit can open Recipe Cost directly on Materials.
  const handleClick = (targetTab = 'Labor') => {
    if(popupOn){handleClickOpenRecipeCost()
    // Old code:
    // setRecipeCostCurrentTab(currentTab)
    // Use targetTab to control which tab opens after redirect.
    setRecipeCostCurrentTab(targetTab)}
    else{navigate(`${PATH_DASHBOARD.project.recipeCost}/${id}`,
      // Old code:
      // {state: { request: params,currentTab : currentTabNew, isEstimateJob:isEstimateJob }});
      // Pass targetTab so caller can explicitly redirect to Materials when needed.
      {state: { request: params,currentTab : targetTab, isEstimateJob:isEstimateJob }});}
  };

  // grandTotalCost = selectedProjects.reduce((accumulator, currentValue) => {
  //   return accumulator + (currentValue.unit_cost * currentValue.quantity);
  // }, 0) + manualTotalPayOut + hourlyTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
  //   let newTotal = 0;
  //   if(currentValue?.taken == 1){
  //     newTotal = currentValue?.originalCost * currentValue?.qty
  //   }
  //   return accumulator + newTotal;
  //   // return accumulator + (currentValue?.originalCost * currentValue?.qty);
  // }, 0) + selectedServices?.reduce((accumulator, currentValue) => {
  //   let newTotal = 0;
  //   if(currentValue?.taken == 1){
  //     newTotal = currentValue?.originalCost * currentValue?.qty
  //   }
  //   return accumulator + newTotal;
  //   // return accumulator + (currentValue?.originalCost * currentValue?.qty);
  // }, 0)) - (manualTotalPayOut ? manualTotalPayOut?.toFixed(2) : 0) + (hourlyTotalPayOut ? hourlyTotalPayOut?.toFixed(2) : 0))

let selectedProjectsTotal = selectedProjects.reduce((accumulator, currentValue) => {
  // Backup before T&M material markup: return accumulator + (currentValue.unit_cost * currentValue.quantity);
  return accumulator + getJobCostMaterialCost(currentValue, isTMProject);
}, 0);

let materialPayOutFormatted = parseFloat(materialPayOut.toFixed(2));

let servicesTotal = services?.reduce((accumulator, currentValue) => {
  let newTotal = 0;
  if (currentValue?.taken === 1) {
      // newTotal = currentValue.originalCost * currentValue.qty;
      newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
  }
  return accumulator + newTotal;
}, 0) || 0;

servicesTotal = parseFloat(servicesTotal.toFixed(2));

let manualTotal = parseFloat((manualTotalPayOut ? manualTotalPayOut.toFixed(2) : 0));
let hourlyTotal = parseFloat((hourlyTotalPayOut ? hourlyTotalPayOut.toFixed(2) : 0));

let totalPayout = Math.max(0, manualTotal + hourlyTotal);

let totalServiceCost = services.reduce((accumulator, currentValue) => {
  // return accumulator + (currentValue.originalCost * currentValue.qty);
  return accumulator + parseFloat(currentValue?.jobcost_total_cost || 0);
}, 0) || 0;

let selectedServicesTotal = selectedServices?.reduce((accumulator, currentValue) => {
  // return accumulator + (currentValue.originalCost * currentValue.qty);
  return accumulator + parseFloat(currentValue?.jobcost_total_cost || 0);
}, 0) || 0;

totalServiceCost += selectedServicesTotal;

// const additionalLaborCost1 = useMemo(() => (
//   services.reduce((sum, service) => {
//     if(details?.job_category_name=='Time & Material'){
//       const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
//       // if (service.recipe_id == null) {
//       if (service.recipe_id == null && service?.taken == 1){
//         return sum + jobcost_total_cost;
//       }
//     }else{
//       const quantity = parseFloat(service.jobcost_quantity || service.qty || 0);
//       const unitCost = parseFloat(service.jobcost_unit_cost || service.originalCost || service.unit_cost || 0);
//       const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
//       // if (service.recipe_id == null) {
//       if (service.recipe_id == null && service.labour_cost_service_id == 10 && service?.taken == 1){
//         sum += jobcost_total_cost;
//       }else if (service.recipe_id == null && service?.taken == 1){
//         // sum += (quantity * unitCost);
//         sum += jobcost_total_cost;
//       }
//     }
//     // if (service.recipe_id == null) {
//     //   return sum + service.jobcost_unit_cost * service.jobcost_quantity;
//     // }
//     return sum;
//   }, 0)
// ), [services, details]);

  // Backup before JobCost recipeCost labor calc alignment:
  // const additionalLaborCost1 = useMemo(() => (
  // services.reduce((sum, service) => {
  //   if (service?.taken !== 1 || service.recipe_id != null || service.labour_cost_service_id === 10) return sum;
  //   const expected = parseFloat((service.originalCost * service.qty) || 0);
  //   const actual   = parseFloat(service.jobcost_total_cost || 0);
  //   const nonExcessAmount = actual > expected ? expected : actual;
  //   return sum + nonExcessAmount;
  // }, 0)
  // ), [services]);

  const additionalLaborCost1 = useMemo(() => (
  services.reduce((sum, service) => {
    if (!includeRecipeCostServiceRow(service) || service.recipe_id != null || service.labour_cost_service_id === 10) return sum;
    const actual = parseFloat(service.jobcost_total_cost || 0);
    const expected = (parseFloat(service.originalCost) || 0) * (parseFloat(service.qty) || 0);
    return sum + (!isTMProject && expected > 0 ? Math.min(actual, expected) : actual);
  }, 0)
), [services, isTMProject]);

  const totalStockCost = useMemo(() => (
    stockProducts.reduce((sum, item) => {
      if (item?.taken !== 1) return sum;

      const cost = parseFloat(item.jobcost_total_cost || 0);
      return sum + cost;
    }, 0)
  ), [stockProducts]);

  /** T&M: align with Material Cost row + quoted service hours (expected), not project.cost alone */
  const tmMaterialPlusServiceBudget = useMemo(() => {
    if (details?.job_category_name !== 'Time & Material') return null;
    const mat =
      parseFloat(materialPayOut || 0) +
      parseFloat(totalStockCost || 0) +
      selectedProjects.reduce(
        // Backup before T&M material markup: (acc, p) => acc + parseFloat(p.unit_cost || 0) * parseFloat(p.quantity || 0),
        (acc, p) => acc + getJobCostMaterialCost(p, true),
        0
      );
    const svcOnJob = (services || []).reduce(
      (acc, s) =>
        s?.taken == 1
          ? acc + parseFloat(s.originalCost || 0) * parseFloat(s.qty || 0)
          : acc,
      0
    );
    const svcCart = (selectedServices || []).reduce(
      (acc, s) => acc + parseFloat(s.originalCost || 0) * parseFloat(s.qty || 0),
      0
    );
    return Number((mat + svcOnJob + svcCart + Number.EPSILON).toFixed(2));
  }, [
    details?.job_category_name,
    materialPayOut,
    totalStockCost,
    selectedProjects,
    services,
    selectedServices
  ]);

  const tmBudgetForDisplay =
    details?.job_category_name === 'Time & Material'
      ? tmMaterialPlusServiceBudget != null && tmMaterialPlusServiceBudget > 0
        ? tmMaterialPlusServiceBudget
        : jobCost
      : jobCost;

  const progressValue = useMemo(() => {
    let tc = selectedProjects.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (currentValue?.taken == 1) {
        // Backup before T&M material markup: newTotal = currentValue?.jobcost_total;
        newTotal = getJobCostMaterialCost(currentValue, isTMProject);
      }
      return accumulator + newTotal;
    }, 0) + manualTotalPayOut + hourlyTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (currentValue?.taken == 1) {
        newTotal = parseFloat(currentValue?.jobcost_total_cost || 0);
      }
      return accumulator + newTotal;
    }, 0) + selectedServices?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (currentValue?.taken == 1) {
        newTotal = parseFloat(currentValue?.jobcost_total_cost || 0);
      }
      return accumulator + newTotal;
    }, 0)) - (parseFloat(manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0) + (hourlyTotalPayOut ? parseFloat(hourlyTotalPayOut) : 0)).toFixed(2));
    const budgetDen =
      details?.job_category_name === 'Time & Material' ? tmBudgetForDisplay : jobCost;
    let Cost = 0;
    if (budgetDen !== 0) {
      Cost = (tc) / budgetDen * 100;
    } else {
      Cost = 100;
    }
    if (Cost > 100) {
      return 100;
    }
    return Cost;
  }, [
    selectedProjects,
    manualTotalPayOut,
    hourlyTotalPayOut,
    materialPayOut,
    jobCost,
    services,
    selectedServices,
    details?.job_category_name,
    isTMProject,
    tmBudgetForDisplay
  ]);

const additionalLaborCost2 = useMemo(() => (
  selectedServices.reduce((sum, service) => {
    if(details?.job_category_name=='Time & Material'){
      const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
      if (service.recipe_id == null && service?.taken == 1){
        return sum + jobcost_total_cost;
      }
    }else{
      const quantity = parseFloat(service.jobcost_quantity || service.qty || 0);
      const unitCost = parseFloat(service.jobcost_unit_cost || service.originalCost || service.unit_cost || 0);
      const jobcost_total_cost = parseFloat(service.jobcost_total_cost || 0);
      if (service.recipe_id == null && service?.taken == 1){
        // return sum + (quantity * unitCost);
        return sum + jobcost_total_cost;
      }
    }
    // if (service.recipe_id == null) {
    //   return sum + service.jobcost_unit_cost * service.jobcost_quantity;
    // }
    return sum;
  }, 0)
), [selectedServices, details]);

// const excessLaborCost1 = useMemo(() => (
//   Math.max(0, manualTotalPayOut + hourlyTotalPayOut - (additionalLaborCost1 + additionalLaborCost2))
// ), [manualTotalPayOut, hourlyTotalPayOut, additionalLaborCost1, additionalLaborCost2]);

// const excessLaborCost1 = useMemo(() => {
//   let labourExpected = 0;
//   let labourActual   = 0;
//   let otherExcess    = 0;
// console.log('excessLaborCost1---services--',services)
//   services.forEach(r => {
//     const expected = r.taken == 1 ? (parseFloat(r.originalCost * r.qty) || 0) : 0;
//     const actual   = r.taken == 1 ? (parseFloat(r.jobcost_total_cost) || 0) : 0;

//     if (+r.labour_cost_service_id === 10) {
//       // Group totals for labour id 10
//       labourExpected += expected;
//       labourActual   += actual;
//     } else {
//       // Per-row excess calculation for others
//       if (actual > expected) {
//         otherExcess += actual - expected;
//       }
//     }
//   });

//   const labourExcess = labourActual > labourExpected
//     ? labourActual - labourExpected
//     : 0;
//   console.log('excessLaborCost1---labourExcess', labourExcess)
//   console.log('excessLaborCost1---otherExcess', otherExcess)
//   console.log('excessLaborCost1---excessHourlyPayoutAmount', excessHourlyPayoutAmount)
//   console.log('excessLaborCost1---excessManualPayoutAmount', excessManualPayoutAmount)
//   return +(labourExcess + otherExcess + (excessHourlyPayoutAmount || 0) + (excessManualPayoutAmount || 0)).toFixed(2);
// }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

// Backup before JobCost recipeCost labor calc alignment (install labor in Excess doubled T&M total):
// const excessLaborCost1 = useMemo(() => {
//   let labourExpected = 0;
//   let labourActual = 0;
//   let otherExcess = 0;
//   let productionExpected = 0;
//   let productionActual = 0;
//   services.forEach(s => {
//     const expected = s.taken == 1 ? (parseFloat(s.originalCost * s.qty) || 0) : 0;
//     const actual = s.taken == 1 ? (parseFloat(s.jobcost_total_cost) || 0) : 0;
//     if (+s.labour_cost_service_id === 10) {
//       labourExpected += expected;
//       labourActual += actual;
//     } else if (s.recipe_id && s.labour_cost_service_id !== 10 && s.taken == 1) {
//       productionExpected += expected;
//       productionActual += actual;
//     } else if (actual > expected) {
//       otherExcess += actual - expected;
//     }
//   });
//   const labourExcess = labourActual > labourExpected ? labourActual - labourExpected : 0;
//   const productionExcess = productionActual > productionExpected ? productionActual - productionExpected : 0;
//   return +(
//     labourExcess +
//     productionExcess +
//     otherExcess +
//     (excessHourlyPayoutAmount || 0) +
//     (excessManualPayoutAmount || 0)
//   ).toFixed(2);
// }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

const excessLaborCost1 = useMemo(() => {
  let productionExpected = 0;
  let productionActual = 0;
  let otherExcess = 0;

  services.forEach((s) => {
    const isTaken = s.taken == 1 || s.billable == 1 || s.is_billable == 1;
    if (!isTaken) return;

    // Install labor (id 10) belongs on Install Labor only — never Excess Labor.
    if (+s.labour_cost_service_id === 10) return;

    const expected = parseFloat(s.originalCost || 0) * parseFloat(s.qty || 0);
    const actual = resolveJobCostServiceLineTotal(s, isTMProject);

    if (s.recipe_id && s.labour_cost_service_id !== 10) {
      productionExpected += expected;
      productionActual += actual;
    } else if (actual > expected) {
      otherExcess += actual - expected;
    }
  });

  const productionExcess = productionActual > productionExpected ? productionActual - productionExpected : 0;
  if (Number(details?.project_category) === 12) return (0).toFixed(2);

  return (
    productionExcess +
    otherExcess +
    (excessHourlyPayoutAmount || 0) +
    (excessManualPayoutAmount || 0)
  ).toFixed(2);
}, [services, excessHourlyPayoutAmount, excessManualPayoutAmount, isTMProject, details?.project_category]);

const installLaborRowCostSum = (services || []).reduce((sum, s) => {
  if (Number(s?.labour_cost_service_id) !== 10) return sum;
  if (!includeRecipeCostServiceRow(s)) return sum;
  return sum + resolveInstallLaborServiceLineCost(s, isTMProject);
}, 0);

const installLaborMetrics = useMemo(() => {
  // Backup before JobCost labor refresh props: const logs = staffTimelogsGet || [];
  const logs = timelogsForCalc || [];
  let costTotal = 0;
  let billTotal = 0;

  const installLaborService = (services || []).find((s) => Number(s.labour_cost_service_id) === 10);
  const serviceRate = resolveInstallLaborServiceUnitCost(installLaborService, isTMProject);
  const serviceBillRate = Number(installLaborService?.bill_unit_price || installLaborService?.unit_bill || 0);

  logs.forEach((log) => {
    if (!isJobCostInstallLaborTimelog(log, services)) return;

    const fallbackR = serviceRate;
    const fallbackBR = isTMProject ? serviceBillRate : 0;
    const computed = getRecipeCostLaborRowComputed(log, fallbackR, fallbackBR, services);

    costTotal += Number(computed?.cost) || 0;

    const isBillable =
      log?.billable === 1 ||
      log?.billable === true ||
      log?.is_billable === 1 ||
      log?.is_billable === true;
    if (isBillable) {
      billTotal += Number(computed?.bill) || 0;
    }
  });

  return { cost: costTotal, bill: billTotal };
}, [timelogsForCalc, services, isTMProject]);

// Backup before JobCost recipeCost labor calc alignment:
// const installLaborCost = useMemo(() => {
//   return services?.reduce((acc, s) => {
//     if (s?.labour_cost_service_id === 10 && s?.taken == 1) {
//       const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
//       const actual = parseFloat(s.jobcost_total_cost || 0);
//       const cost = expected > actual ? actual : expected;
//       return acc + cost;
//     }
//     return acc;
//   }, 0).toFixed(2);
// }, [services]);

const installLaborCost = useMemo(() => {
  const installRows = (services || []).filter(
    (s) => Number(s.labour_cost_service_id) === 10 && includeRecipeCostServiceRow(s)
  );
  // Backup before require jobcost_quantity > 0 (empty qty zeroed Install Labor in add-material):
  // const manualRows = installRows.filter((s) => s.jobcost_quantity != null && s.jobcost_quantity !== '');
  // let actualCost = installLaborMetrics.cost;
  // if (manualRows.length > 0) {
  //   const sumFromServices = installRows.reduce(
  //     (sum, s) => sum + resolveInstallLaborServiceLineCost(s, isTMProject), 0
  //   );
  //   actualCost = Math.max(installLaborRowCostSum, sumFromServices);
  // }
  const manualRows = installRows.filter(
    (s) => s.jobcost_quantity != null && s.jobcost_quantity !== '' && parseFloat(s.jobcost_quantity) > 0
  );

  let actualCost = Number(installLaborMetrics.cost) || 0;
  if (manualRows.length > 0) {
    const sumFromServices = installRows.reduce(
      (sum, s) => sum + resolveInstallLaborServiceLineCost(s, isTMProject),
      0
    );
    const serviceTotal = Math.max(installLaborRowCostSum, sumFromServices);
    const metrics = Number(installLaborMetrics.cost) || 0;
    // ALL-1209: Prefer service/list amount (matches Labor tab Service Cost).
    if (serviceTotal <= 0) {
      actualCost = metrics;
    } else if (metrics > serviceTotal + 1) {
      actualCost = metrics;
    } else {
      actualCost = serviceTotal;
    }
  }

  return actualCost.toFixed(2);
}, [installLaborMetrics, installLaborRowCostSum, services, isTMProject]);

// Backup before JobCost recipeCost labor calc alignment:
// const manuallyAddedPayoutsTotal = useMemo(() => {
//   return manuallyAddedPayouts?.filter(
//     p => !isJobCostInstallLaborPayout(p, services)
//   )?.reduce(
//     (sum, p) => sum + parseFloat(p.amount || 0), 0
//   ) || 0;
// }, [manuallyAddedPayouts, services]);
// const productionLabourTotal = useMemo(() => {
//   const filtered = services?.filter(
//     s => s?.recipe_id && s?.labour_cost_service_id !== 10 && s?.taken == 1
//   );
//   const expected = filtered.reduce((sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0), 0);
//   const actual   = filtered.reduce((sum, s) => sum + parseFloat(s.jobcost_total_cost || 0), 0);
//   const regularProductionLabour = Math.min(expected, actual);
//   const used = regularProductionLabour + manuallyAddedPayoutsTotal;
//   return used.toFixed(2);
// }, [services, manuallyAddedPayoutsTotal]);

const productionLabourTotal = useMemo(() => {
  const filtered = (services || []).filter(
    (s) => s?.recipe_id && s?.labour_cost_service_id !== 10 && includeRecipeCostServiceRow(s)
  );

  const expected = filtered.reduce((sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0), 0);
  const actual = filtered.reduce(
    (sum, s) => sum + (parseFloat(s.jobcost_total_cost) || parseFloat(s.total_cost) || 0),
    0
  );

  let manuallyAddedPayoutsTotal = 0;

  if (Number(details?.project_category) === 12) {
    const manuallyAddedPayoutsForTM = (allPayouts || []).filter(
      (p) =>
        (p.is_manually_added === 1 || p.is_manually_added === '1') &&
        !isJobCostInstallLaborPayout(p, services)
    );
    manuallyAddedPayoutsTotal = manuallyAddedPayoutsForTM.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0),
      0
    );
  } else {
    manuallyAddedPayoutsTotal =
      manuallyAddedPayouts?.filter((p) => !isJobCostInstallLaborPayout(p, services))?.reduce(
        (sum, p) => sum + parseFloat(p.amount || 0),
        0
      ) || 0;
  }

  const regularProductionLabour =
    !isTMProject && expected > 0 ? Math.min(actual, expected) : actual;
  const used = regularProductionLabour + manuallyAddedPayoutsTotal;

  return used.toFixed(2);
}, [services, manuallyAddedPayouts, allPayouts, details?.project_category, isTMProject]);

const productionTimelogLaborCost = useMemo(() => {
  // Backup before JobCost labor refresh props: const logs = staffTimelogsGet || [];
  const logs = timelogsForCalc || [];
  const installLaborService = (services || []).find((s) => Number(s.labour_cost_service_id) === 10);
  const installServiceRate = resolveInstallLaborServiceUnitCost(installLaborService, isTMProject);
  let total = 0;
  logs.forEach((log) => {
    if (isJobCostInstallLaborTimelog(log, services)) return;
    total += getJobCostTimelogLineCost(log, isTMProject, installServiceRate);
  });
  return Math.round((total + Number.EPSILON) * 100) / 100;
}, [timelogsForCalc, services, isTMProject]);

// Backup before JobCost labor refresh props:
// const effectiveProductionLabor = useMemo(
//   () => Math.max(Number(productionLabourTotal || 0), productionTimelogLaborCost),
//   [productionLabourTotal, productionTimelogLaborCost]
// );

const effectiveProductionLabor = useMemo(() => {
  const tabMemberLabor = Number(laborTabLaborCost ?? 0);
  // Backup before production labor tab-priority fix:
  // return Math.max(
  //   Number(productionLabourTotal || 0),
  //   productionTimelogLaborCost,
  //   tabMemberLabor
  // );
  return resolveEffectiveProductionLabor({
    recipeLabor: productionLabourTotal,
    timelogLabor: productionTimelogLaborCost,
    tabLabor: tabMemberLabor,
    isTM: isTMProject,
  });
}, [productionLabourTotal, productionTimelogLaborCost, laborTabLaborCost, isTMProject]);

const summaryMaterialCost = useMemo(
  () =>
    parseFloat(
      (
        materialPayOutFormatted +
        selectedProjectsTotal +
        parseFloat(totalStockCost || 0)
      ).toFixed(2)
    ),
  [materialPayOutFormatted, selectedProjectsTotal, totalStockCost]
);

const otherTotals = useMemo(() => getOtherEntriesTotals(otherEntries), [otherEntries]);

// Backup before JobCost recipeCost labor calc alignment:
// const additionalAmount = ((excessManualPayoutAmount || 0) + (excessHourlyPayoutAmount || 0)) || 0;
// grandTotalCost = materialPayOutFormatted + selectedProjectsTotal + servicesTotal + totalStockCost + (additionalAmount > 0 ? additionalAmount : 0) + manuallyAddedPayoutsTotal;
// grandTotalCost = parseFloat(grandTotalCost.toFixed(2));

const grandTotalCost = useMemo(() => {
  const productionLine = Number(effectiveProductionLabor || 0);
  const installLine = Number(installLaborCost || 0);
  const excessLine = isTMProject ? 0 : Number(excessLaborCost1 || 0);

  return parseFloat(
    (
      summaryMaterialCost +
      Number(additionalLaborCost1 || 0) +
      productionLine +
      installLine +
      Number(otherTotals?.cost || 0) +
      excessLine
    ).toFixed(2)
  );
}, [
  summaryMaterialCost,
  additionalLaborCost1,
  effectiveProductionLabor,
  installLaborCost,
  excessLaborCost1,
  otherTotals,
  isTMProject
]);

console.log('grandTotalCost', grandTotalCost)

console.log('servicesservices=12=selectedProjectsTotal==',selectedProjectsTotal);
console.log('servicesservices=12=materialPayOutFormatted==',materialPayOutFormatted);
console.log('servicesservices=12=servicesTotal==',servicesTotal);
console.log('servicesservices=12=totalPayout==',totalPayout);
console.log('servicesservices=12=manualTotalPayOut==',manualTotalPayOut);
console.log('servicesservices=12=hourlyTotalPayOut==',hourlyTotalPayOut);
console.log('servicesservices=12=additionalLaborCost1==',additionalLaborCost1);
console.log('servicesservices=12=additionalLaborCost2==',additionalLaborCost2);

console.log('servicesservices=12=totalServiceCost==',totalServiceCost);
console.log('servicesservices=12=services==',services);

// {Math.max(0, (
//   parseFloat((manualTotalPayOut ? manualTotalPayOut.toFixed(2) : 0)) + 
//   parseFloat((hourlyTotalPayOut ? hourlyTotalPayOut.toFixed(2) : 0))) - 
//   Math.max(0, (services?.reduce((accumulator, currentValue) => {
//   return accumulator + (currentValue?.originalCost * currentValue?.qty);
// }, 0) + selectedServices?.reduce((accumulator, currentValue) => {
//   return accumulator + (currentValue?.originalCost * currentValue?.qty);
// }, 0)))).toFixed(2)}

  return (
    (loading || !details) ?
      <Stack alignItems='center' justifyContent='center' mt={10}>
        <LoadingScreen />
      </Stack> 
    :
      <Page title={`Job Calculator |${COMPANY_NAME}`} mt={3}>
        <Container>
         {!isModal && (popupOn ? <Button
            variant="outlined"
            type="button"
            // component={RouterLink}
            // to={PATH_DASHBOARD.project.viewproject + id}
            // onClick={()=>{navigate(`${PATH_DASHBOARD.project.viewproject}/${id}`,
            //   {state: { currentTab : currentTabNew }})}}
            onClick={handleBackToAlljobs}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to Job Details
          </Button> :
          <Button
          variant="outlined"
          type="button"
          // component={RouterLink}
          // to={PATH_DASHBOARD.project.viewproject + id}
          onClick={()=>{
            isEstimateJob ? (
              navigate(`${PATH_DASHBOARD.quotation.viewEstimateProject}/${id}`,
              {state: { currentTab : currentTabNew }})
            ) : (
              navigate(`${PATH_DASHBOARD.project.viewproject}/${id}`,
              {state: { currentTab : currentTabNew }})
            )
          }}
          // onClick={handleBackToAlljobs}
          sx={{ alignItems: 'flex-end', mb: 4 }}
          startIcon={
            <Stack>
              <KeyboardBackspaceOutlined />
            </Stack>
          }
        >
          Back to Job Details
        </Button>)}

          <Button
            variant="outlined"
            type="button"
            onClick={()=>{ setJobCostPreview(true); }}
            sx={{ alignItems: 'flex-end', mb: 4, ml:4 }}
          >
            Expected V/S Actual
          </Button>

          <Stack direction={'row'} spacing={2} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Box width={'30%'}>
              <HeaderBreadcrumbs
                heading={
                <>
                  {"Job Calculator"} {details?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
                </>}
              />
            </Box>

            {/* <Box width={'50%'}> */}
            <Stack spacing={2} mb={5} sx={{ mr: '7% !important' }} width={'50%'}>
              {details?.job_category_name === 'Time & Material' ? 
                <Typography variant="subtitle2">Expected Budget (Material + Service) : {Number(tmBudgetForDisplay || 0).toFixed(2)}</Typography>
              :
                <Typography variant="subtitle2">Expected Budget (Product Formula Cost + Labor Cost) : {jobCost}</Typography>
              }
              <Box sx={{ display: 'flex', alignItems: 'center', }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                  <BorderLinearProgress variant="determinate" value={progressValue} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                  <Typography variant="body2" color="text.secondary">{Math.round(progressValue) || 0}%</Typography>
                </Box>
              </Box>
            </Stack>
            {/* </Box> */}
          </Stack>
          {console.log("################44", linkState)}
          {/* <Button
            variant="outlined"
            type="button"
            onClick={handleClick}
            sx={{ alignItems: 'flex-end', mb: 4 }}
          >
            Go to Product Formula Cost
          </Button> */}
          {!isTabRestricted && !popupOn && !isModal && (
            <Button
              variant="outlined"
              type="button"
              onClick={handleClick}
              sx={{ alignItems: 'flex-end', mb: 4 }}
            >
              Go to Product Formula Cost
            </Button>
          )}
          {/* Old code: <Grid container spacing={3}> */}
          <Grid container spacing={3} sx={{ position: 'relative' }}>
            {isMaterialDeleteLoading && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  zIndex: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 450,
                  borderRadius: 2,
                  backgroundColor: alpha(theme.palette.background.default, 0.72),
                  backdropFilter: 'blur(2px)'
                }}
              >
                <CircularProgress size={34} />
                <Typography variant="body2" sx={{ mt: 2 }}>
                  Loading materials...
                </Typography>
              </Box>
            )}
            <Grid item md={5} xs={12}>
              <Tabs
                value={currentTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChangeTab}
              // sx={{pb:2}}      
              >
                {ACCOUNT_TABS.map((tabItem) => (
                  <Tab sx={{ px: 3 }}
                    disableRipple
                    key={tabItem.value}
                    label={
                      // <Badge badgeContent={tabItem.count} color="primary">
                      <Typography variant="overline">{capitalCase(tabItem.name)}</Typography>
                      // </Badge>
                    }
                    // icon={tabItem.icon}
                    value={tabItem.value}
                  />
                ))}
              </Tabs>
              <Tabs
                value={selectedCategory}
                sx={{
                  backgroundColor: theme.palette.grey[700],
                  borderRadius: 2,
                  mb: 1,
                }}
                onChange={(e, newValue) => handleCategoryChange(newValue)}
                variant="scrollable"
                aria-label="scrollable auto tabs example"
                allowScrollButtonsMobile
                autoFocus
                scrollButtons="auto"
              >
                {category.map((category) => (
                  <Tab key={category.id}
                    disableRipple
                    autoCapitalize={category.name}
                    label={category.name}
                    value={category.id} />
                ))}
              </Tabs>
              <SearchStyle
                sx={{ backgroundColor: 'var(--signwise-app-chrome-toolbar)', height: 40 }}
                value={filterName}
                onChange={handleFilterByName}
                placeholder={currentTab == "STOCK CATALOGS" ? "Search Catalog" : "Search Material"}
                startAdornment={
                  <InputAdornment position="start">
                    <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                }
              />
              {(currentTab === 'Materials' || currentTab === 'STOCK CATALOGS') && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', my: 1 }}>
                  <Box
                    role="group"
                    aria-label="Material and catalog stock filter"
                    sx={{
                      position: 'relative',
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      width: 252,
                      p: 0.5,
                      borderRadius: 2,
                      overflow: 'hidden',
                      backgroundColor: theme.palette.grey[700],
                      border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
                      boxShadow: `inset 0 0 16px ${alpha(theme.palette.common.black, 0.4)}`,
                    }}
                  >
                    <Box
                      aria-hidden
                      sx={{
                        position: 'absolute',
                        top: 4,
                        bottom: 4,
                        left: inStockOnly ? 'calc(50% + 4px)' : '4px',
                        width: 'calc(50% - 8px)',
                        borderRadius: 1.5,
                        backgroundColor: inStockOnly
                          ? theme.palette.success.main
                          : theme.palette.primary.main,
                        boxShadow: inStockOnly
                          ? `0 0 8px ${alpha(theme.palette.success.main, 0.35)}`
                          : `0 0 8px ${alpha(theme.palette.primary.main, 0.35)}`,
                        transition:
                          'left 0.45s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.45s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
                        willChange: 'left',
                      }}
                    />
                    {[
                      {
                        label: 'All',
                        value: false,
                        icon: gridFill,
                        activeColor: theme.palette.primary.contrastText,
                      },
                      {
                        label: 'In Stock',
                        value: true,
                        icon: checkmarkCircle2Fill,
                        activeColor: theme.palette.success.contrastText,
                      },
                    ].map((opt) => {
                      const active = inStockOnly === opt.value;
                      return (
                        <Box
                          key={opt.label}
                          component="button"
                          type="button"
                          onClick={() => setInStockOnly(opt.value)}
                          sx={{
                            position: 'relative',
                            zIndex: 1,
                            border: 'none',
                            outline: 'none',
                            py: 0.75,
                            px: 1,
                            borderRadius: 1.5,
                            cursor: 'pointer',
                            backgroundColor: 'transparent',
                            color: active ? opt.activeColor : theme.palette.text.secondary,
                            fontWeight: active ? 700 : 500,
                            fontSize: '0.65rem',
                            letterSpacing: '0.08em',
                            textTransform: 'uppercase',
                            fontFamily: 'inherit',
                            transition: 'color 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                              color: active ? opt.activeColor : theme.palette.text.primary,
                            },
                          }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            spacing={0.6}
                          >
                            <Icon icon={opt.icon} width={15} height={15} />
                            <Box component="span">{opt.label}</Box>
                          </Stack>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
              <Card
                sx={{
                  p: 3,
                  height: '450px',
                  overflow: 'hidden',
                  backgroundColor: 'transparent',
                  background: 'transparent',
                  boxShadow: 'none',
                  border: `1px solid ${theme.palette.grey[500_32]}`,
                  // overflowY: 'auto',
                  // '&::-webkit-scrollbar': {
                  //   width: '0.4em',
                  // },
                  // '&::-webkit-scrollbar-track': {
                  //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  //   webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  // },
                  // '&::-webkit-scrollbar-thumb': {
                  //   backgroundColor: 'rgba(0,0,0,.1)',
                  //   borderRadius: '4px',
                  // },
                }}
              >
                  {/* Backup: previous material grid map (catalogWithStock / materialWithStock)
                                  {console.log("###########selectedCategory", category.length + 1, selectedCategory)}
                                  <Grid container spacing={1}>
                  
                                    {currentTab != "Materials" ? (
                                      // Render content based on recipe
                                      // <>
                                      //   {console.log("###########Product Formula", recipe)}
                                      //   {
                                      //     allServices?.map((service, index) => (
                                      //       <Grid key={index} item xs={6} sm={4} md={4}> // Adjusted md to 4
                                      //         <Card
                                      //           onMouseEnter={() => setIsHover(true)}
                                      //           onMouseLeave={() => setIsHover(false)}
                                      //           sx={{
                                      //             minWidth: 100,
                                      //             transition: 'transform 0.2s',
                                      //             '&:hover': {
                                      //               transform: 'scale(1.02)',
                                      //             },
                                      //           }}
                                      //           // onClick={() => { setMaterialsPreview(true); setIsRecipe(true); setSelectedMaterial(recipeItem) }}
                                      //           onClick={() => { handleAddService(service) }}
                                      //         >
                                      //           {service.name}
                                      //         </Card>
                                      //       </Grid>
                                      //     ))}
                                      // </>
                                 <>
                                  {catalogWithStock?.filter(material => (
                                        (filterName ? material.name.toLowerCase().includes(filterName.toLowerCase()) : true) &&
                  
                                        (selectedCategory && selectedCategory !== 1212121 ? material.category_id === selectedCategory : true)
                                      ))?.map((post, index) => (
                                        <Grid key={index} item xs={6} sm={4} md={4}>
                                          <Card
                                            onMouseEnter={() => setIsHover(true)}
                                            onMouseLeave={() => setIsHover(false)}
                                            sx={{
                                              minWidth: 100,
                                              transition: 'transform 0.2s',
                                              '&:hover': {
                                                transform: 'scale(1.02)',
                                              },
                                              cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
                                            }}
                                            onClick={() => { (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? null : setMaterialsPreview(true); setSelectedMaterial(post) }}
                                          >
                                            <Box sx={{ 
                                              p: 2,
                                              textAlign: 'center',
                                              justifyContent: 'center',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              // height: 'auto',
                                              height: '80px',
                                              overflow: 'hidden',
                                             }}>
                                              <Stack
                                                direction={'row'}
                                                justifyContent={'center'}
                                                alignItems={'center'}
                                                sx={{
                                                  height: '100%',
                                                }}
                                              >
                                                <Tooltip title={post.name + ` (${post?.inhouse ? 'Inhouse' : 'Client owned'})`}>
                                                  <Typography
                                                    variant="body2"
                                                    align="center"
                                                    sx={{
                                                      display: '-webkit-box',
                                                      WebkitBoxOrient: 'vertical',
                                                      overflow: 'hidden',
                                                      textOverflow: 'ellipsis',
                                                      WebkitLineClamp: 3,
                                                      lineHeight: '1.2',
                                                      maxHeight: '3.6em',
                                                      fontSize: '14px',
                                                      // cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
                                                    }}
                                                  >
                                                    // {post.name + ` (${post?.inhouse ? 'I' : 'C'})`}
                                                    // {post.name}
                                                  </Typography>
                                                </Tooltip>
                                              </Stack>
                                            </Box>
                                            <Divider />
                                            <Box sx={{ 
                                              p: 2,
                                              textAlign: 'center',
                                              justifyContent: 'center',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              height: 'auto',
                                              overflow: 'hidden',
                                            }}>
                                              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                                                <Typography
                                                  variant="caption"
                                                  align="center"
                                                  sx={{
                                                    marginTop: 0.5,
                                                    fontSize: '12px',
                                                    // color: 'gray',
                                                  }}
                                                >
                                                  Stock : {post?.finishedProductQty}
                                                </Typography>
                                              </Stack>
                                            </Box>
                                          </Card>
                                        </Grid>
                                      ))}
                                 </>
                  
                                    ) : (
                                      materialWithStock?.filter(material => (
                                        (filterName ? material.name.toLowerCase().includes(filterName.toLowerCase()) : true) &&
                  
                                        (selectedCategory && selectedCategory !== 1212121 ? material.category_id === selectedCategory : true)
                                      ))?.map((post, index) => (
                                        <Grid key={index} item xs={6} sm={4} md={4}>
                                          <Card
                                            onMouseEnter={() => setIsHover(true)}
                                            onMouseLeave={() => setIsHover(false)}
                                            sx={{
                                              minWidth: 100,
                                              transition: 'transform 0.2s',
                                              '&:hover': {
                                                transform: 'scale(1.02)',
                                              },
                                              cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
                                            }}
                                            onClick={() => { (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? null : setMaterialsPreview(true); setSelectedMaterial(post) }}
                                          >
                                            <Box sx={{ 
                                              p: 2,
                                              textAlign: 'center',
                                              justifyContent: 'center',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              // height: 'auto',
                                              height: '80px',
                                              overflow: 'hidden',
                                             }}>
                                              <Stack
                                                direction={'row'}
                                                justifyContent={'center'}
                                                alignItems={'center'}
                                                sx={{
                                                  height: '100%',
                                                }}
                                              >
                                                <Tooltip title={post.name + ` (${post?.inhouse ? 'Inhouse' : 'Client owned'})`}>
                                                  <Typography
                                                    variant="body2"
                                                    align="center"
                                                    sx={{
                                                      display: '-webkit-box',
                                                      WebkitBoxOrient: 'vertical',
                                                      overflow: 'hidden',
                                                      textOverflow: 'ellipsis',
                                                      WebkitLineClamp: 3,
                                                      lineHeight: '1.2',
                                                      maxHeight: '3.6em',
                                                      fontSize: '14px',
                                                      // cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
                                                    }}
                                                  >
                                                    {post.name + ` (${post?.inhouse ? 'I' : 'C'})`}
                                                  </Typography>
                                                </Tooltip>
                                              </Stack>
                                            </Box>
                                            <Divider />
                                            <Box sx={{ 
                                              p: 2,
                                              textAlign: 'center',
                                              justifyContent: 'center',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              height: 'auto',
                                              overflow: 'hidden',
                                            }}>
                                              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                                                <Typography
                                                  variant="caption"
                                                  align="center"
                                                  sx={{
                                                    marginTop: 0.5,
                                                    fontSize: '12px',
                                                    // color: 'gray',
                                                  }}
                                                >
                                                  Stock : {post?.total_qty}
                                                </Typography>
                                              </Stack>
                                            </Box>
                                          </Card>
                                        </Grid>
                                      )))}
                  */}
                  {currentTab != "Materials" ? (
                    <MaterialPickerGrid
                      key={`catalog-${selectedCategory}-${filterName}-${inStockOnly}`}
                      items={filteredCatalogList}
                      isTabRestricted={isTabRestricted}
                      showOwnershipSuffix={false}
                      getStockQty={getCatalogStockQty}
                      onCardClick={handlePickerCardClick}
                      allowOutOfStockClick={isTMProject}
                    />
                  ) : (
                    <MaterialPickerGrid
                      key={`material-${selectedCategory}-${filterName}-${inStockOnly}`}
                      items={filteredMaterialList}
                      isTabRestricted={isTabRestricted}
                      showOwnershipSuffix
                      getStockQty={getMaterialStockQty}
                      onCardClick={handlePickerCardClick}
                      allowOutOfStockClick={isTMProject}
                    />
                  )}
              </Card>
            </Grid>

          <Grid item md={7} xs={12}>
            <Card>
              <Box sx={{ display: 'flex', alignItems: 'center', py: 2, pl: 3 }}>
                <Typography variant="h4" noWrap>Expense</Typography>
              </Box>
              <Box sx={{ width: "100%", display: "flex", alignItems: 'center', justifyContent: "flex-end", my: 2, mr: 5 }}>
                    {/* Color indicators for stock types */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 2 }}>
                     
                      {
                        details?.job_category_name == 'Time & Material' ? ""
                        :
                        <>
                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      
                         <Tooltip title={"The material quantity will update according to the expected quantity. Once the expected quantity is reached, the available quantity will decrease accordingly."} placement="top" arrow>
                                  <IconButton size="small" sx={{ color: 'text.secondary' }} aria-label="QuickBooks job cost accounting info">
                                    <Info fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                      </Box>
                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "black" : "#ffffff", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Additional Materials</Typography>
                      </Box>
                      
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: "#1ccaff", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Stock Catalogs</Typography>
                      </Box>
                      </>
                      }
                    </Box>
                  </Box>

              <FormikProvider value={formik}>
                <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <Scrollbar
                    sx={{
                      height: '320px'
                    }}>
                    <TableContainer sx={{ minWidth: 550 }} ref={tableContainerRef}>
                      <Table>
                        <TableHead
                          sx={{
                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                            '& th': { backgroundColor: 'transparent' }
                          }}
                        >
                          <TableRow>
                            {/* <TableCell align="left">
                          <Typography variant="body1" noWrap>ID</Typography>
                        </TableCell> */}
                          <TableCell align="center"></TableCell>
                          <TableCell align="center"></TableCell>

                            <TableCell align="center">
                              <Typography variant="body1" >Name & Barcode</Typography>
                            </TableCell>
                            {!isTMProject && (
                              <TableCell align="center">
                                <Typography variant="body1" noWrap>Expt Qty</Typography>
                              </TableCell>
                            )}
                            <TableCell align="center">
                              <Typography variant="body1" noWrap>Quantity</Typography>
                            </TableCell>
                          
                            {
                            details?.project_category == 12 ? "" :
                            <TableCell align="center">
                              <Typography variant="body1" noWrap>
                                Product/Service <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                              </Typography>
                            </TableCell>
                             }
                            <TableCell align="center">
                              <Typography variant="body1" noWrap>Total </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Typography variant="body1" noWrap></Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>

                          <TableBody>
                            {selectedProjects?.map((selectedProject, index) => {
                              let qtyExceed = 0
                              console.log('selectedProject---', selectedProject);
                              let unitNameNew = UNITS?.filter((item) => item?.id == selectedProject?.unit)
                              let unitName = unitNameNew?.[0]?.name || '';
                              let shortUnitName = unitNameNew?.[0]?.short_name || "";
                              return (
                                <TableRow
                                  key={selectedProject.id}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                  }}
                                >

                                     <TableCell padding="checkbox" onClick={handleScrollRight}>
                                    <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                    <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                                      </IconButton>
                                    </TableCell>

                                       <TableCell align="center">
                                          {(selectedProject?.taken == 1 &&  details?.syncWithQuickbooks) ? 
                                          <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                           :""}
                                      </TableCell>
                                  <TableCell align="center">
                                    <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                    <Tooltip title={selectedProject?.name + (selectedProject?.isMaterial ==1 ? (selectedProject?.inhouse == 1 ? ' (Inhouse)' : ' (Client owned)')+(selectedProject?.partial==1?'Partial':'Finished') :"")}>
                                      <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',color:selectedProject?.isMaterial ==1 ? "" : "#1ccaff"}}>
                                        {selectedProject?.name} { selectedProject?.isMaterial ==1 ? selectedProject?.inhouse == 1 ? ' (I)' : ' (C)' : ""}
                                      </Typography>
                                    </Tooltip>
                                      <Typography variant="subtitle2" sx={{color:selectedProject?.isMaterial ==1 ? "" : "#1ccaff"}}>{selectedProject?.barcode}</Typography>
                                      <span style={{ color:  theme.palette.error.main }}>
                                        {selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                          const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                          const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                          const stock = isTMProject ? productQuantity : (initialQuantity + productQuantity) - currentValue?.quantity;
                                          return stock >= 0 ? ('Stock left : ' + stock.toFixed(2)) : '';
                                        }, 0) || ''}
                                      </span>
                                    </Box>
                                  </TableCell>
                                     {!isTMProject && (
                                       <TableCell align='center'>{selectedProject?.match_actual_quantity||0} <span>({shortUnitName})</span></TableCell>
                                     )}
                                  {/* <TableCell>{index + 1}</TableCell> */}
                                  {/* <TableCell align="left">1</TableCell> */}
                                  <TableCell align="center" sx={{display:"flex",flexDirection:"column"}}>
                                    <TextField
                                      sx={{ width: '80%' }}
                                      type='number'
                                      disabled = {(currentTabNew =="Installations" || currentTabNew =="Completed" || currentTabNew == "Hold") ? true : false}
                                      label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                      value={selectedProject.quantity}
                                      onKeyPress={(event) => {
                                        // console.log('errorFieldId------',errorFieldId)
                                        if (event.key === '0' && event.target.value === '0') {
                                          event.preventDefault();
                                        }
                                        if (event.key === '0' && event.target.value === '') {
                                          event.preventDefault();
                                        }
                                        // if (event.key === '.') {
                                        //   event.preventDefault();
                                        // }
                                        if (event.key === '-') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onChange={(event) => {
                                        // console.log('errorFieldId--2----',errorFieldId)
                                        let newValue = event.target.value;
                                        if (newValue.startsWith('-')) {
                                          newValue = newValue.slice(1);
                                        }
                                        const updatedProjects = selectedProjects.map(p => {
                                          if (p.id === selectedProject.id) {
                                            return {
                                              ...p,
                                              quantity: newValue,
                                              ...getJobCostMaterialRowTotals(p, isTMProject, newValue)
                                            };
                                          }
                                          return p;
                                        });
                                        const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                          const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                          const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                          const stock = initialQuantity + productQuantity;
                                          const balanceStock = stock - event.target.value;
                                          return (!isTMProject && balanceStock < 0)
                                        }, 0) || 0

                                        setSelectedProjects(updatedProjects);
                                      }}
                                      error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id && data.errorText !== 'Product/Service is required') || ''}
                                      helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id && field.errorText !== 'Product/Service is required')?.errorText || ''}
                                      // error={Boolean(touched.quantity && errors.quantity)}
                                      // helperText={touched.quantity && errors.quantity}
                                      InputProps={{
                                        inputProps: {
                                          min: 1,
                                          max: () => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                            return initialQuantity + productQuantity;
                                          }
                                        }
                                      }}
                                      defaultValue={1}
                                    />
                                    <span style={{ color: theme.palette.error.main, fontSize: 12 }}>
                                      {(errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id)) ? '' : (selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                        const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                        const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                        const stock = initialQuantity + productQuantity;
                                        const balance = stock - currentValue?.quantity;
                                        return (!isTMProject && balance < 0) ? ((selectedProject?.unit == 4) ? "Quantity exceeds the stock" : unitName + ' exceeds the stock') : ((currentValue?.quantity <= 0) ? ((selectedProject?.unit == 4) ? "Enter a valid quantity" : 'Enter a valid ' + unitName) : '')
                                      }, 0) || '')}
                                    </span>
                                    {/* <TextField
                                    sx={{ width: '80%', borderColor: (qtyExceed || errors.quantity) ? theme.palette.error.main : theme.palette.success.main }}
                                    type='number'
                                    label="Quantity"
                                    {...getFieldProps('quantity')}
                                    error={(qtyExceed || errors.quantity) && touched.quantity}
                                    helperText={(qtyExceed || errors.quantity) && touched.quantity ? "Quantity exceeds the stock" : ""}
                                    InputProps={{
                                      inputProps: {
                                        min: 1,
                                        max: () => {
                                          const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                          const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                          return initialQuantity + productQuantity;
                                        },
                                      },
                                    }}
                                    defaultValue={1}
                                  /> */}
                                  </TableCell>
                                  {
                                    details?.project_category == 12 ? "" :
                                  
                                  <TableCell align="center">
                                    {
                                      selectedProject?.isMaterial == 1 ? 
                                    <Box sx={{ width: '100%' }}>
                                      <Tooltip title={futureInstallations?.find(item => item?.location_id === selectedProject?.for_product || item?.location_id === selectedProject?.for_service)?.name || ''}>
                                    <Autocomplete
                                    sx={{ width: '200px' }}
                                      options={futureInstallations}
                                      getOptionLabel={(option) => option?.name}
                                      value={futureInstallations?.find(item => item?.location_id === selectedProject?.for_product || item?.location_id === selectedProject?.for_service)}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Product/Service"
                                          required
                                          error={Boolean(errorFieldId?.find(field => field.productId === selectedProject.id && field.errorText === 'Product/Service is required'))}
                                          helperText={errorFieldId?.find(field => field.productId === selectedProject.id && field.errorText === 'Product/Service is required')?.errorText || ''}
                                        />
                                      )}
                                      onChange={(event, newValue) => {
                                        console.log('newValue---',newValue)
                                        const updatedProjects = selectedProjects.map(p => {
                                          if (p.id === selectedProject.id) {
                                            return {
                                              ...p,
                                              for_product: newValue?.IsProductInstallation ? newValue?.location_id : null,
                                              for_service: newValue?.IsServiceInstallation ? newValue?.location_id : null
                                            };
                                          }
                                          return p;
                                        });
                                        setSelectedProjects(updatedProjects);
                                        setErrorFieldId((prev) => prev.filter((field) => !(field.productId === selectedProject.id && field.errorText === 'Product/Service is required')));
                                      }}
                                    />
                                    </Tooltip>
                                    </Box>
                                    :
                                    "N/A"
                                  }
                                  </TableCell>
                            }

                                {/* <TableCell align="center">${selectedProject?.unit_cost?.toFixed(2)}</TableCell> */}
                                {/* Backup before T&M material markup: <TableCell align="center">{fCurrency(Number(selectedProject?.unit_cost) * Number(selectedProject?.quantity))}</TableCell> */}
                                <TableCell align="center">{fCurrency(getJobCostMaterialCost(selectedProject, isTMProject))}</TableCell>
                                {/* <TableCell align="center">{fCurrency(Number(selectedProject?.total))}</TableCell> */}
                                <TableCell align="center">
                                  {(currentTabNew =="Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? '' :
                                  <IconButton onClick={() => { setOpenDeletePop(true); setDeleteId(selectedProject?.id) }} >
                                    <Icon icon={trash2Outline} width={20} height={20} />
                                  </IconButton>
                                  }
                                  <ConfirmationPopup
                                    open={openDeletePop}
                                    handleClose={() => { setOpenDeletePop(false); setDeleteId() }}
                                    message={`You want to delete ! `}
                                    handleClick={() => { setOpenDeletePop(false); handleDeleteSubmit(deleteId) }}
                                  />
                                </TableCell>
                                {/* <ConfirmationPopup open={isDelete} handleClick={()=>handleDeleteTask(row.ID,row.project_id)} message={'Want to Delete This Task'} handleClose={()=>setIsDelete(false)}/> */}
                      
                           <TableCell padding="checkbox" onClick={handleScrollLeft}>
                               <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                  <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                             </IconButton>
                               </TableCell>
                              
                                                         

                              </TableRow>
                            )
                          })}
                          {selectedServices?.map((service, serviceIndex) => (
                            <TableRow
                              key={`service_${serviceIndex}`}
                              sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,

                                }}
                              >
                                <TableCell align="center">
                                  <Typography variant="subtitle2" style={{ color: 'yellow' }}>{service.name}</Typography>
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Typography variant="subtitle2" style={{ color: 'yellow' }}>Service</Typography>
                                </TableCell> */}
                                <TableCell align="center">
                                  <TextField
                                    sx={{ width: '80%', color: 'yellow' }}
                                    type='number'
                                    label="Hours"
                                    value={service.qty}
                                    onChange={(e) => handleQuantityChange(serviceIndex, e.target.value)}
                                    InputProps={{
                                      inputProps: {
                                        min: 1
                                      }
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.originalCost}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2" style={{ color: 'yellow' }}>${(service.qty) * (service.originalCost)}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <IconButton onClick={() => handleDeleteService((serviceIndex))} >
                                    <Icon icon={trash2Outline} width={20} height={20} />
                                  </IconButton>

                                </TableCell>
                              </TableRow>
                            ))
                            }

                          </TableBody>
                        </Table>
                      </TableContainer>

                    </Scrollbar>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Box>
                    <RowResultStyle>
                      {/* <TableCell colSpan={3} /> */}
                      <TableCell align="right" colSpan={4} >
                        {/* <Typography variant="h6">{details?.job_category_name=='Time & Material' ? "Material Cost" : "Additional Material Cost"}</Typography> */}
                        <Typography variant="h6">{"Material Cost"}</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{
                            // selectedProjects.reduce((accumulator, currentValue) => {
                          //   return (parseFloat(accumulator) + (currentValue.unit_cost * currentValue.quantity)).toFixed(2);
                          // }, 0)
                            summaryMaterialCost.toFixed(2)
                          }
                          {/* Backup before JobCost recipeCost labor calc alignment:
                            (
                              parseFloat(materialPayOut || 0) + parseFloat(totalStockCost || 0) +
                              selectedProjects.reduce((accumulator, currentValue) => {
                                // Backup before T&M material markup: return accumulator + (parseFloat(currentValue.unit_cost || 0) * parseFloat(currentValue.quantity || 0));
                                return accumulator + getJobCostMaterialCost(currentValue, isTMProject);
                              }, 0)
                            ).toFixed(2)
                          */}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    {/* {details?.job_category_name=='Time & Material' ? '' : */}
                      <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Additional Services</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {parseFloat(additionalLaborCost1).toFixed(2)}
                            {/* {details?.job_category_name=='Time & Material' ? '0.00' :
                            (services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue.recipe_id == null && currentValue?.taken == 1){
                                newTotal = currentValue?.originalCost * currentValue?.qty
                              }
                              return accumulator + newTotal;
                            }, 0) || 0).toFixed(2)} */}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    {/* } */}

                    { /*<RowResultStyle>
                    
                      <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Additional Labour Cost</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{selectedServices.reduce((accumulator, currentValue) => {
                          return accumulator + (currentValue.originalCost * currentValue.qty);
                        }, 0)}</Typography>
                      </TableCell>
                      </RowResultStyle>*/}
                    {/* {details?.job_category_name=='Time & Material' ? '' : */}
                      <RowResultStyle>
                        {/* <TableCell  width={240}/> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">Actual Product Formula Cost</Typography> */}
                          <Typography variant="h6">Production Labor</Typography>

                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="h6" sx={{ whiteSpace: { xs: 'none', md: 'nowrap' }}}>
                            {/* {`${(materialPayOut + services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.taken == 1)){
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                              }
                              return accumulator + newTotal;
                            }, 0) || 0).toFixed(2)} (${(materialPayOut || 0).toFixed(2)} + ${(services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue.recipe_id && currentValue?.taken == 1){
                                const initialCost = currentValue?.originalCost * currentValue?.qty
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                              }
                              return accumulator + newTotal;
                              // return accumulator + (currentValue?.originalCost * currentValue?.qty);
                            }, 0) || 0).toFixed(2)})`} */}
                            { parseFloat(effectiveProductionLabor).toFixed(2)}
                            {/* Backup before JobCost labor refresh props: { parseFloat(productionLabourTotal).toFixed(2)} */}
                          </Typography>
                        </TableCell>


                      </RowResultStyle>
                      <RowResultStyle>
                      <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Install Labor</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">
                          { parseFloat(installLaborCost).toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Equipment Cost</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">
                          {parseFloat(otherTotals?.cost || 0).toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    {/* } */}
                    {/* Backup before T&M category type fix: {details?.project_category !== 12 && ( */}
                    {!isTMProject && (
                      <RowResultStyle>
                        {/* <TableCell colSpan={3} /> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">{details?.job_category_name=='Time & Material' ? "Service Cost" : "Excess Labor Cost"}</Typography> */}
                          <Typography variant="h6">Excess Labor Cost</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {/* {details?.job_category_name=='Time & Material' ? 
                            (parseFloat(additionalLaborCost1)).toFixed(2) :  */}
                            {parseFloat(excessLaborCost1).toFixed(2)}
                            {/* } */}
                            {/* {Math.max(0, (parseFloat((manualTotalPayOut ? manualTotalPayOut.toFixed(2) : 0)) + parseFloat((hourlyTotalPayOut ? hourlyTotalPayOut.toFixed(2) : 0))) - Math.max(0, (services?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.originalCost * currentValue?.qty);
                          }, 0) + selectedServices?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.originalCost * currentValue?.qty);
                          }, 0)))).toFixed(2)} */}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    )}
                    {/* <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Manual Staff Pay Out</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{manualTotalPayOut ? manualTotalPayOut?.toFixed(2) : 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
                    {/* <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Hourly Staff Pay Out</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{hourlyTotalPayOut ? hourlyTotalPayOut?.toFixed(2) : 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}

                    <RowResultStyle>
                      {/* <TableCell colSpan={3} />  */}
                      {/* <TableCell align="center" width={240}> */}
                      <TableCell align="right" colSpan={4} sx={{color:'#fc8c03'}} >
                        <Typography variant="h6">Total Cost</Typography>

                      </TableCell>
                      <TableCell align="center" width={100} sx={{color:'#fc8c03'}}>
                        <Typography variant="h6">{grandTotalCost ? grandTotalCost?.toFixed(2) : 0}</Typography>

                      </TableCell>

                    </RowResultStyle>
                    </Box>
                    </Box>
                    {(currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? '' :
                    <Box sx={{ display: 'flex', justifyContent: 'center', }}>
                      {/* Old code:
                      <LoadingButton loading={isSubmitting} sx={{ borderRadius: '20px', mx: 3, mb: 1, width: '80%' }} type="submit" variant="contained">
                      */}
                      <LoadingButton loading={isSubmitting || isMaterialDeleteLoading} disabled={isMaterialDeleteLoading} sx={{ borderRadius: '20px', mx: 3, mb: 1, width: '80%' }} type="submit" variant="contained">
                        Submit
                      </LoadingButton>
                    </Box>
                    }
                  </Form>
                </FormikProvider>
              </Card>
            </Grid>
          </Grid>
        </Container>
        {materialsPreview && (
          <Modal
            open={materialsPreview}
            handleClose={() => {
              setMaterialsPreview(false);
              setIsRecipe(false)
            }}
            modalTitle={`${currentTab == "STOCK CATALOGS" ? "Select Catalog" : "Select material"}`}
          >
            {isRecipe ? (
              <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                <Grid item xs={12} md={10}>
                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                    spacing={3}
                  >
                    <Stack
                      direction={{ xs: 'column', md: 'column' }}
                      display="flex"
                      justifyContent="space-between"
                      spacing={3}
                    >
                      {console.log("#####selectedMaterial", selectedMaterial?.ingredients)}
                      <Stack direction={{ xs: 'column', md: 'column' }}>
                        <Stack>
                          <Typography variant="body">
                           {currentTab == "STOCK CATALOGS" ? "Catalog Name :" : "Material Name :"}
                            <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold' }}>

                              <Autocomplete
                                sx={{ width: 400 }}
                                id="combo-box-demo"
                                options={selectedMaterial.ingredients}
                                value={ingredient}
                                onChange={(event, newValue) => setIngredient(newValue)}
                                renderInput={(params) => (
                                  <TextField {...params}

                                    label="Select a Material" />
                                )}
                                getOptionLabel={(option) => option.name ? option.name : ''}

                              />
                            </span>

                          </Typography>
                        </Stack>
                      </Stack>

                      {/* <Card> */}
                      <Scrollbar>
                        <TableContainer>
                          <Table>
                            <TableHead sx={{ width: '100%' }}>
                              <TableRow>
                                <TableCell align='center'>#</TableCell>
                                <TableCell align='center'>Barcode</TableCell>
                                <TableCell align='center'>Unit Cost</TableCell>
                                <TableCell align='center'>Available Stock</TableCell>
                                <TableCell align='center'></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {loading ? (
                                <CircularProgress color="primary" variant="indeterminate" />
                              ) : (
                                <>
                                  {productWithQty?.filter((data) => (data?.material_id === ingredient?.product_id)).map((row, index) => {
                                    // console.log('selectedProjects------',selectedProjects);
                                    // console.log('selectedMaterial------',selectedMaterial);
                                    let { id, name, unit_cost, qty, barcode } = row;
                                    // Backup before T&M markup display: let quantity = selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity || 1;
                                    const ingredientMaterial = selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id);
                                    let quantity = ingredientMaterial?.quantity || 1;
                                    const displayUnitCost = getJobCostMaterialCost({
                                      ...row,
                                      markup: ingredientMaterial?.markup || ingredientMaterial?.retail_price || selectedMaterial?.retail_price || row?.markup || 0,
                                      markup_percent: ingredientMaterial?.markup_percent || row?.markup_percent,
                                      material_markup_percentage: ingredientMaterial?.material_markup_percentage || ingredientMaterial?.retail_price || selectedMaterial?.retail_price || row?.material_markup_percentage || row?.markup,
                                      product_markup: ingredientMaterial?.product_markup || row?.product_markup
                                    }, isTMProject, {
                                      qty: 1,
                                      unitCost: row?.inhouse === 0 ? 0 : unit_cost
                                    });
                                    console.log("&&&&&&&&&&&&&Qty", quantity);
                                    return (
                                      <TableRow
                                        hover
                                        key={index}
                                        tabIndex={-1}
                                        sx={{
                                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                        }}
                                      >
                                        <TableCell align='center'> {index + 1} </TableCell>
                                        <TableCell align="center"> {barcode} </TableCell>
                                        <TableCell align="center">
                                          {/* Backup before T&M markup display: ${unit_cost} */}
                                          ${displayUnitCost}
                                        </TableCell>
                                        <TableCell align="center"> {qty} </TableCell>
                                        <TableCell align="center">
                                          {/* Backup before T&M markup display: onClick={() => !selectedProjects.map(s => s.id).includes(id) ? handleProjectClick({ ...row, quantity }) : enqueueSnackbar('Material Already Added', { variant: 'error' })} */}
                                          <Button
                                            onClick={() => !selectedProjects.map(s => s.id).includes(id) ? handleProjectClick({
                                              ...row,
                                              quantity,
                                              markup: ingredientMaterial?.markup || ingredientMaterial?.retail_price || selectedMaterial?.retail_price || row?.markup || 0,
                                              markup_percent: ingredientMaterial?.markup_percent || row?.markup_percent,
                                              material_markup_percentage: ingredientMaterial?.material_markup_percentage || ingredientMaterial?.retail_price || selectedMaterial?.retail_price || row?.material_markup_percentage || row?.markup,
                                              product_markup: ingredientMaterial?.product_markup || row?.product_markup
                                            }) : enqueueSnackbar('Material Already Added', { variant: 'error' })}
                                          >
                                            <AddCircle />
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      {/* </Card> */}
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                        <Button variant='outlined' onClick={() => { setMaterialsPreview(false); setSelectedMaterial(null); }}>Close</Button>
                      </Box>
                    </Stack>

                  </Stack>
                </Grid>
              </Grid>) :
              (<Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                <Grid item xs={12} md={10}>
                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                    spacing={3}
                  >
                    <Stack
                      direction={{ xs: 'column', md: 'column' }}
                      display="flex"
                      justifyContent="space-between"
                      spacing={3}
                    >
                      {console.log("#####selectedMaterial", selectedMaterial)}
                      <Stack direction={{ xs: 'column', md: 'column' }}>
                        <Typography variant="body">
                          Material Name : <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold' }}>{selectedMaterial?.name} {selectedMaterial?.inhouse == 1 ? 'Inhouse' : 'Client owned'}</span>
                        </Typography>
                      </Stack>

                      {/* <Card> */}
                      <Scrollbar>
                        <TableContainer>
                          <Table>
                            <TableHead sx={{ width: '100%' }}>
                              <TableRow>
                                <TableCell align='center'>#</TableCell>
                                <TableCell align='center'>Barcode</TableCell>
                                <TableCell align='center'>Unit Cost</TableCell>
                                <TableCell align='center'>Available Stock</TableCell>
                                <TableCell align='center'></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {loading ? (
                                <CircularProgress color="primary" variant="indeterminate" />
                              ) : (
                                <>
                                  {productWithQty?.filter((data) => (data?.material_id === selectedMaterial?.id)).map((row, index) => {
                                    // console.log('selectedProjects------',selectedProjects);
                                    // console.log('selectedMaterial------',selectedMaterial);
                                    let { id, name,inhouse, unit_cost, qty, barcode } = row;
                                    const displayUnitCost = getJobCostMaterialCost({
                                      ...row,
                                      markup: selectedMaterial?.markup || selectedMaterial?.retail_price || row?.markup || 0,
                                      markup_percent: selectedMaterial?.markup_percent || row?.markup_percent,
                                      material_markup_percentage: selectedMaterial?.material_markup_percentage || selectedMaterial?.retail_price || row?.material_markup_percentage || row?.markup,
                                      product_markup: selectedMaterial?.product_markup || row?.product_markup
                                    }, isTMProject, {
                                      qty: 1,
                                      unitCost: inhouse == 0 ? 0 : unit_cost
                                    });
                                    return (
                                      <TableRow
                                        hover
                                        key={index}
                                        tabIndex={-1}
                                        sx={{
                                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                        }}
                                      >
                                        <TableCell align='center'> {index + 1} </TableCell>
                                        <TableCell align="center"> {barcode} </TableCell>
                                        <TableCell align="center">
                                          {/* Backup before T&M markup display: ${inhouse == 0 ? '0' : unit_cost} */}
                                          ${displayUnitCost}
                                        </TableCell>
                                        <TableCell align="center"> {qty} </TableCell>
                                        <TableCell align="center">
                                          {/* Backup before T&M markup display: onClick={() => !selectedProjects.map(s => s.id).includes(id) ? handleProjectClick({ ...row, quantity: 1 }) : enqueueSnackbar('Material Already Added', { variant: 'error' })} */}
                                          <Button
                                            onClick={() => !selectedProjects.map(s => s.id).includes(id) ? handleProjectClick({
                                              ...row,
                                              quantity: 1,
                                              markup: selectedMaterial?.markup || selectedMaterial?.retail_price || row?.markup || 0,
                                              markup_percent: selectedMaterial?.markup_percent || row?.markup_percent,
                                              material_markup_percentage: selectedMaterial?.material_markup_percentage || selectedMaterial?.retail_price || row?.material_markup_percentage || row?.markup,
                                              product_markup: selectedMaterial?.product_markup || row?.product_markup
                                            }) : enqueueSnackbar('Material Already Added', { variant: 'error' })}
                                          >
                                            <AddCircle />
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      {/* </Card> */}
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                        <Button variant='outlined' onClick={() => { setMaterialsPreview(false); setSelectedMaterial(null); }}>Close</Button>
                      </Box>
                    </Stack>

                  </Stack>
                </Grid>
              </Grid>)}
          </Modal>
        )}
        {jobCostPreview && (
          <Modal
            open={jobCostPreview}
            handleClose={() => {
              setJobCostPreview(false);
            }}
            modalTitle={
              <>
              {"Job Cost Calculator "}
              {details?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
              </>
            }
            width={1200}
          >
            <CompareJobCost id={id} laborTabLaborCost={laborTabLaborCost} staffTimelogsProp={staffTimelogsProp} refreshTrigger={refreshTrigger} />
          </Modal>
        )}
      </Page>
  );
}
